
/* PriceDex kaartdetail-pop-up voor de lokale mockup.
   Overgenomen uit public/assets/cw-pricedex.js (openCardDetail en alles wat ze nodig heeft),
   met deze bewuste aanpassingen voor file://:
   - data komt uit de ingebakken momentopname <script type="application/json" id="pricedex-cards">
   - altijd de ingelogde weergave (geen paywall), zoals de eigenaar het ziet
   - geen history.replaceState, geen tracking, geen fetch naar /account.json of andere shop-API's
   - inline onclick-handlers vervangen door data-pdxm-* attributen met een gedelegeerde klik
   - em/en-streepjes uit de copy vervangen (bv. "Stabiele trend" krijgt een pijl)
   Enkel window.PDXModal = { open(k), close(), isOpen() } gaat naar buiten. */
(function () {
'use strict';

/* ---------- Instellingen ---------- */
var CWCR_PD_BASE = '/apps/kaarten';
var PD_ORIGIN = 'https://cardworld.be';
var SHOP_URL = 'https://cardworld.be/collections/all';
var IS_LIGHT = true; /* PriceDex zet cwcr-theme-light altijd aan; hier draagt .pdxm-root die klasse */
/* Logo van de "Shop bij Cardworld"-knop: verkleinde kopie van Logo_Cardworld_Single.png (44 px) */
var CWCR_LOGO_URL = 'data:image/png;base64,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';

/* Teksten per taal. NL overgenomen uit window.CWPD_I18N (loc = nl) in cw-pricedex.liquid; FR en EN erbij (16 okt).
   De taal komt van <html lang> (applyLang in app.js zet die); I18N wijst bij elke opening naar de juiste set,
   ontbrekende sleutels vallen terug op NL. */
var I18N_NL = {
  overview:'Overzicht',priceAnalysis:'Analyse prijs',tabAnalysis:'Prijsanalyse',signals:'Signalen',market:'Markt',
  nearMintPrice:'Near Mint Prijs',nmWorldwide:'Near Mint (Wereldwijd)',nmEU:'Near Mint (EU)',nmRegion:'Near Mint regio',tcgMarketPrice:'TCGplayer Richtprijs',tcgPrice:'TCGplayer Prijs',currentPrice:'Huidige prijs',
  lowest:'Voordeligst',trend:'Trend',avgSale:'Gem. Verkoop',avgSalePrice:'Gem. Verkoopprijs',trendPrice:'Trendprijs',lowestPrice:'Voordeligst',
  avg1d:'Gem. 1D',avg7d:'Gem. 7D',avg30d:'Gem. 30D',average1d:'Gemiddelde 1D',average7d:'Gemiddelde 7D',average30d:'Gemiddelde 30D',
  d1:'1D',d7:'7D',d30:'30D',
  evoAllConditions:'Evolutie Alle Condities',evoNearMint:'Prijsevolutie Near Mint',evoNoData:'Nog niet genoeg prijsdata voor deze nieuwe set',nmEvoPrices:'Gemiddeld NM prijsverloop',
  evoAllTitle:'Evolutie alle condities',evoNmTitle:'Evolutie Near-Mint prijzen',
  evo1d:'Evolutie 1D',evo7d:'Evolutie 7D',evo30d:'Evolutie 30D',
  risingTrend:'Stijgende trend',fallingTrend:'Dalende trend',stableTrend:'Stabiele trend',highVolatility:'Hoge volatiliteit',buyOpportunity:'Onder de trendprijs',
  priceAnalysisTitle:'Prijsanalyse',priceTrend:'Prijstrend',volatility:'Volatiliteit',nmVsTrend:'NM vs Trend',priceSpan:'Prijsspanning',
  rising:'Stijgend',falling:'Dalend',stable:'Stabiel',low:'Laag',medium:'Medium',high:'Hoog',
  aboveTrend:'boven trend',belowTrend:'onder trend',lowToAvg:'laag - gem.',
  notEnoughData:'Niet genoeg data voor prijssignalen.',noPriceData:'Geen prijsdata beschikbaar',noChartData:'Geen grafiekdata beschikbaar',
  showFullTable:'Toon volledige prijstabel',hideTable:'Verberg prijstabel',nmPrices:'Near Mint prijzen',priceAverages:'Prijsgemiddelden',priceEvolution:'Prijsevolutie',
  worldwide:'Wereldwijd',europe:'Europa',world:'Wereld',euBtn:'EU',
  priceOverview:'Prijsoverzicht',cardDetails:'Kaartgegevens',cardmarketId:'Cardmarket ID',setLabel:'Set',rarity:'Zeldzaamheid',color:'Kleur',
  edition:'Editie',source:'Bron',nmEuOnly:'Near Mint (EU)',historicalNotAvailable:'USD via TCGplayer, historische data niet beschikbaar',usdViaTcg:'USD via TCGplayer',usdMarketNotAvailable:'USD via TCGplayer, EU-marktdata niet beschikbaar',
  usdNoChart:'USD via TCGplayer: geen historische Cardmarket-grafiek beschikbaar',
  zoom:'Zoom',zoomTitle:'Vergroot kaart',cardInfo:'Kaartinfo',flipTitle:'Bekijk kaartinfo',share:'Deel',shareCard:'Deel met vrienden',shareText:'Bekijk {name} op CARDWORLD PriceDex.',thisCard:'deze kaart',copyCardLink:'Kopieer kaartlink',copied:'Gekopieerd!',copyFailed:'Mislukt',shopAtCw:'Shop bij Cardworld',addToCollection:'+ Voeg toe aan collectie',viewCmSource:'Bekijk bronprijs op Cardmarket',viewOnTcg:'Bekijk op TCGplayer',
  oneDay:'1D gem',sevenDay:'7D gem',thirtyDay:'30D gem',now:'Nu',ref:'Ref',
  rarityLabel:'Zeldzaamheid',numberLabel:'Nummer',setLabelBack:'Set',typeLabel:'Type',colorLabel:'Kleur',priceLabel:'Prijs',
  allSellers:'Alle Cardmarket-verkopers wereldwijd',onlyEuSellers:'Enkel verkopers in de EU',sellers:'verkopers',
  copyDeeplink:'Kopieer deeplink',close:'Sluiten',prevCard:'Vorige kaart',nextCard:'Volgende kaart',
  colRed:'Rood',colGreen:'Groen',colBlue:'Blauw',colPurple:'Paars',colBlack:'Zwart',colYellow:'Geel',colMulti:'Meerkleurig'
};
var I18N_FR = {
  overview:'Aperçu',priceAnalysis:'Analyse de prix',tabAnalysis:'Analyse',signals:'Signaux',market:'Marché',
  nearMintPrice:'Prix Near Mint',nmWorldwide:'Near Mint (monde)',nmEU:'Near Mint (UE)',nmRegion:'Région Near Mint',tcgMarketPrice:'Prix indicatif TCGplayer',tcgPrice:'Prix TCGplayer',currentPrice:'Prix actuel',
  lowest:'Le moins cher',trend:'Tendance',avgSale:'Vente moy.',avgSalePrice:'Prix de vente moy.',trendPrice:'Prix tendance',lowestPrice:'Le moins cher',
  avg1d:'Moy. 1J',avg7d:'Moy. 7J',avg30d:'Moy. 30J',average1d:'Moyenne 1J',average7d:'Moyenne 7J',average30d:'Moyenne 30J',
  d1:'1J',d7:'7J',d30:'30J',
  evoAllConditions:'Évolution toutes conditions',evoNearMint:'Évolution du prix Near Mint',evoNoData:'Pas encore assez de données de prix pour ce nouveau set',nmEvoPrices:'Évolution moyenne du prix NM',
  evoAllTitle:'Évolution toutes conditions',evoNmTitle:'Évolution des prix Near Mint',
  evo1d:'Évolution 1J',evo7d:'Évolution 7J',evo30d:'Évolution 30J',
  risingTrend:'Tendance à la hausse',fallingTrend:'Tendance à la baisse',stableTrend:'Tendance stable',highVolatility:'Forte volatilité',buyOpportunity:'Sous le prix tendance',
  priceAnalysisTitle:'Analyse de prix',priceTrend:'Tendance du prix',volatility:'Volatilité',nmVsTrend:'NM vs tendance',priceSpan:'Écart de prix',
  rising:'En hausse',falling:'En baisse',stable:'Stable',low:'Faible',medium:'Moyenne',high:'Élevée',
  aboveTrend:'au-dessus de la tendance',belowTrend:'sous la tendance',lowToAvg:'bas - moy.',
  notEnoughData:'Pas assez de données pour les signaux de prix.',noPriceData:'Aucune donnée de prix disponible',noChartData:'Aucune donnée de graphique disponible',
  showFullTable:'Afficher le tableau complet',hideTable:'Masquer le tableau',nmPrices:'Prix Near Mint',priceAverages:'Moyennes de prix',priceEvolution:'Évolution du prix',
  worldwide:'Monde',europe:'Europe',world:'Monde',euBtn:'UE',
  priceOverview:'Aperçu des prix',cardDetails:'Détails de la carte',cardmarketId:'ID Cardmarket',setLabel:'Set',rarity:'Rareté',color:'Couleur',
  edition:'Édition',source:'Source',nmEuOnly:'Near Mint (UE)',historicalNotAvailable:'USD via TCGplayer, pas de données historiques',usdViaTcg:'USD via TCGplayer',usdMarketNotAvailable:'USD via TCGplayer, pas de données du marché UE',
  usdNoChart:'USD via TCGplayer : pas de graphique Cardmarket historique',
  zoom:'Zoom',zoomTitle:'Agrandir la carte',cardInfo:'Infos carte',flipTitle:'Voir les infos de la carte',share:'Partager',shareCard:'Partager avec des amis',shareText:'Découvre {name} sur CARDWORLD PriceDex.',thisCard:'cette carte',copyCardLink:'Copier le lien',copied:'Copié !',copyFailed:'Échec',shopAtCw:'Acheter chez Cardworld',addToCollection:'+ Ajouter à la collection',viewCmSource:'Voir le prix source sur Cardmarket',viewOnTcg:'Voir sur TCGplayer',
  oneDay:'Moy. 1J',sevenDay:'Moy. 7J',thirtyDay:'Moy. 30J',now:'Auj.',ref:'Réf.',
  rarityLabel:'Rareté',numberLabel:'Numéro',setLabelBack:'Set',typeLabel:'Type',colorLabel:'Couleur',priceLabel:'Prix',
  allSellers:'Tous les vendeurs Cardmarket dans le monde',onlyEuSellers:'Vendeurs UE uniquement',sellers:'vendeurs',
  copyDeeplink:'Copier le lien',close:'Fermer',prevCard:'Carte précédente',nextCard:'Carte suivante',
  colRed:'Rouge',colGreen:'Vert',colBlue:'Bleu',colPurple:'Violet',colBlack:'Noir',colYellow:'Jaune',colMulti:'Multicolore'
};
var I18N_EN = {
  overview:'Overview',priceAnalysis:'Price analysis',tabAnalysis:'Analysis',signals:'Signals',market:'Market',
  nearMintPrice:'Near Mint price',nmWorldwide:'Near Mint (worldwide)',nmEU:'Near Mint (EU)',nmRegion:'Near Mint region',tcgMarketPrice:'TCGplayer market price',tcgPrice:'TCGplayer price',currentPrice:'Current price',
  lowest:'Lowest',trend:'Trend',avgSale:'Avg. sale',avgSalePrice:'Avg. sale price',trendPrice:'Trend price',lowestPrice:'Lowest',
  avg1d:'Avg. 1D',avg7d:'Avg. 7D',avg30d:'Avg. 30D',average1d:'Average 1D',average7d:'Average 7D',average30d:'Average 30D',
  d1:'1D',d7:'7D',d30:'30D',
  evoAllConditions:'Change, all conditions',evoNearMint:'Near Mint price change',evoNoData:'Not enough price data yet for this new set',nmEvoPrices:'Average NM price history',
  evoAllTitle:'Change, all conditions',evoNmTitle:'Change, Near Mint prices',
  evo1d:'Change 1D',evo7d:'Change 7D',evo30d:'Change 30D',
  risingTrend:'Rising trend',fallingTrend:'Falling trend',stableTrend:'Stable trend',highVolatility:'High volatility',buyOpportunity:'Below trend price',
  priceAnalysisTitle:'Price analysis',priceTrend:'Price trend',volatility:'Volatility',nmVsTrend:'NM vs trend',priceSpan:'Price spread',
  rising:'Rising',falling:'Falling',stable:'Stable',low:'Low',medium:'Medium',high:'High',
  aboveTrend:'above trend',belowTrend:'below trend',lowToAvg:'low - avg.',
  notEnoughData:'Not enough data for price signals.',noPriceData:'No price data available',noChartData:'No chart data available',
  showFullTable:'Show full price table',hideTable:'Hide price table',nmPrices:'Near Mint prices',priceAverages:'Price averages',priceEvolution:'Price change',
  worldwide:'Worldwide',europe:'Europe',world:'World',euBtn:'EU',
  priceOverview:'Price overview',cardDetails:'Card details',cardmarketId:'Cardmarket ID',setLabel:'Set',rarity:'Rarity',color:'Colour',
  edition:'Edition',source:'Source',nmEuOnly:'Near Mint (EU)',historicalNotAvailable:'USD via TCGplayer, no historical data',usdViaTcg:'USD via TCGplayer',usdMarketNotAvailable:'USD via TCGplayer, no EU market data',
  usdNoChart:'USD via TCGplayer: no historical Cardmarket chart',
  zoom:'Zoom',zoomTitle:'Enlarge card',cardInfo:'Card info',flipTitle:'View card info',share:'Share',shareCard:'Share with friends',shareText:'Check out {name} on CARDWORLD PriceDex.',thisCard:'this card',copyCardLink:'Copy card link',copied:'Copied!',copyFailed:'Failed',shopAtCw:'Shop at Cardworld',addToCollection:'+ Add to collection',viewCmSource:'View source price on Cardmarket',viewOnTcg:'View on TCGplayer',
  oneDay:'1D avg',sevenDay:'7D avg',thirtyDay:'30D avg',now:'Now',ref:'Ref',
  rarityLabel:'Rarity',numberLabel:'Number',setLabelBack:'Set',typeLabel:'Type',colorLabel:'Colour',priceLabel:'Price',
  allSellers:'All Cardmarket sellers worldwide',onlyEuSellers:'EU sellers only',sellers:'sellers',
  copyDeeplink:'Copy deeplink',close:'Close',prevCard:'Previous card',nextCard:'Next card',
  colRed:'Red',colGreen:'Green',colBlue:'Blue',colPurple:'Purple',colBlack:'Black',colYellow:'Yellow',colMulti:'Multicolour'
};
var I18N = I18N_NL;
var LANG = 'nl';
/* Taal van de pagina: <html lang> (nl, fr of en; DE blijft verborgen en valt terug op NL) */
function curLang(){
  var l=''; try{ l=String(document.documentElement.lang||'').slice(0,2).toLowerCase(); }catch(e){ l=''; }
  return (l==='fr' || l==='en') ? l : 'nl';
}
/* Zet I18N op de huidige taal (NL als vangnet per sleutel) en vertaal de vaste teksten in de opmaak */
function applyLang(){
  LANG=curLang();
  var extra=LANG==='fr' ? I18N_FR : LANG==='en' ? I18N_EN : null;
  var T={}, k;
  for(k in I18N_NL) T[k]=I18N_NL[k];
  if(extra) for(k in extra) T[k]=extra[k];
  I18N=T;
  var root=$('pdxm-root');
  if(!root) return;
  root.querySelectorAll('[data-pdxm-i18n]').forEach(function(el){ var v=T[el.getAttribute('data-pdxm-i18n')]; if(v!=null) el.textContent=v; });
  root.querySelectorAll('[data-pdxm-i18n-title]').forEach(function(el){ var v=T[el.getAttribute('data-pdxm-i18n-title')]; if(v!=null) el.setAttribute('title',v); });
  root.querySelectorAll('[data-pdxm-i18n-aria]').forEach(function(el){ var v=T[el.getAttribute('data-pdxm-i18n-aria')]; if(v!=null) el.setAttribute('aria-label',v); });
  var navB=$('cwcr-nav');
  if(navB){
    var pb=navB.querySelector('[data-nav="-1"]'), nb=navB.querySelector('[data-nav="1"]');
    if(pb) pb.setAttribute('aria-label',T.prevCard);
    if(nb) nb.setAttribute('aria-label',T.nextCard);
  }
}
/* Getallen in Belgische notatie, zoals de rest van de pagina (eur() in app.js: "€ 769,97").
   NL en EN volgen nl-BE (zelfde euro-notatie als de kaartlijst), FR volgt fr-BE. */
function numLoc(){ return LANG==='fr' ? 'fr-BE' : 'nl-BE'; }
function nf(n,dec){
  var v=Number(n)||0;
  try{ return v.toLocaleString(numLoc(),{ minimumFractionDigits:dec, maximumFractionDigits:dec }); }
  catch(e){ return v.toFixed(dec).replace('.',','); }
}
/* 16 okt (audit 2): een negatief bedrag kreeg "€ -3.250,00"; het minteken staat nu voor het euroteken ("-€ 3.250,00") */
function money(n,sym){ var v=Number(n)||0; return (v<=-0.005?'-':'')+(sym||'€')+' '+nf(Math.abs(v),2); }
/* Percentage met komma; plus-teken enkel bij een positieve waarde als signed */
function pct(v,signed){ return (signed && v>0 ? '+' : '')+nf(v,1)+'%'; }
/* Kleur van een One Piece-kaart (kaartdata in het Engels, ook "Red/Green") naar de taal van de pagina */
function colorName(c){
  return String(c||'').split('/').map(function(p){
    var s=p.trim(), key='col'+s.charAt(0).toUpperCase()+s.slice(1).toLowerCase();
    return I18N[key] || s;
  }).join('/');
}
/* Landnaam in de taal van de pagina, met de NL-lijst als terugval */
function countryName(code){
  try{ if(window.Intl && Intl.DisplayNames){ var n=new Intl.DisplayNames([LANG==='fr' ? 'fr-BE' : LANG==='en' ? 'en-GB' : 'nl-BE'],{ type:'region' }).of(code); if(n && n!==code) return n; } }catch(e){}
  return countryNames[code] || code;
}

/* ---------- Helpers uit cw-pricedex.js ---------- */
/* Pokemon prijs: NM Lowest eerst, dan averageSellPrice, trendPrice, avg30/7/1 */
function cwcrCmPrice(cp){
  if(!cp) return 0;
  return cp.lowestNearMint || cp.averageSellPrice || cp.trendPrice || cp.avg30 || cp.avg7 || cp.avg1 || 0;
}
function esc(s){
  return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}
/* Gedeelde kaart-image resolver: primaire bron + deterministische fallbacks */
function cwcrResolveCardImg(c, fr){
  var isOp = (fr === 'onepiece' || fr === 'onepiece-bulk');
  if(isOp){
    var apiImg = c.image_url || c.image || c.card_image || c.img || c.picture ||
      (c.images && (c.images.en || c.images.ja || c.images.url)) || '';
    var cardId = c.card_id || c.id || '';
    if(!cardId && apiImg){ var m=apiImg.match(/\/([A-Z]{2,4}\d+-\d+)(?:_|\.)/i); if(m) cardId=m[1].toUpperCase(); }
    var ltUrl = '';
    if(cardId){
      var setFolder = cardId.split('-')[0].replace(/^([A-Za-z]+)(\d+)$/, function(_,l,n){ return l.toLowerCase()+'-'+n; });
      ltUrl = 'https://limitlesstcg.nyc3.cdn.digitaloceanspaces.com/op/' + setFolder + '/' + cardId + '_EN.webp';
    }
    var fbLt = cardId ? 'https://limitlesstcg.nyc3.cdn.digitaloceanspaces.com/op/' + cardId.split('-')[0].toLowerCase() + '/' + cardId + '_EN.webp' : '';
    var primary = apiImg || ltUrl || '';
    var fbs = [ltUrl, fbLt, apiImg].filter(function(u){ return u && u !== primary; });
    return { src: primary, fallbacks: fbs };
  }
  var pkImg = (c.images && (c.images.small || c.images.large)) || c.image_url || c.image || '';
  var ptcg = '';
  var pid = c.id || '';
  if(pid && pid.indexOf('-') > -1){
    var i = pid.lastIndexOf('-');
    var prefix = pid.slice(0, i), num = pid.slice(i+1);
    if(prefix && num) ptcg = 'https://images.pokemontcg.io/' + prefix + '/' + num + '.png';
  }
  var pkPrimary = pkImg || ptcg || '';
  var pkFbs = [ptcg].filter(function(u){ return u && u !== pkPrimary; });
  return { src: pkPrimary, fallbacks: pkFbs };
}
/* Detail-modal hero image met dezelfde fallback-cascade als de grids */
function cwcrSetModalImg(imgEl, card, fr, altName){
  if(!imgEl) return;
  var r = cwcrResolveCardImg(card, fr);
  imgEl.alt = altName || '';
  imgEl.style.display = '';
  var queue = r.fallbacks ? r.fallbacks.slice() : [];
  imgEl.onerror = function(){
    if(queue.length){ imgEl.src = queue.shift(); return; }
    imgEl.onerror = null; imgEl.removeAttribute('src'); imgEl.style.display = 'none';
  };
  if(r.src){ imgEl.style.display = ''; imgEl.src = r.src; }
  else { imgEl.onerror = null; imgEl.removeAttribute('src'); imgEl.style.display = 'none'; }
}
var pkRarity={
'Special Illustration Rare': { label: 'Special Illustration Rare',cls: 'cwcr-badge-sir',pri: 1,abbr:'SIR' },'Special illustration rare': { label: 'Special Illustration Rare',cls: 'cwcr-badge-sir',pri: 1,abbr:'SIR' },'Hyper Rare':                { label: 'Hyper Rare',cls: 'cwcr-badge-hr',pri: 2,abbr:'HR' },'Hyper rare':                { label: 'Hyper Rare',cls: 'cwcr-badge-hr',pri: 2,abbr:'HR' },'ACE SPEC Rare':             { label: 'ACE SPEC',cls: 'cwcr-badge-hr',pri: 2,abbr:'ACE' },'Illustration Rare':         { label: 'Illustration Rare',cls: 'cwcr-badge-ir',pri: 3,abbr:'IR' },'Illustration rare':         { label: 'Illustration Rare',cls: 'cwcr-badge-ir',pri: 3,abbr:'IR' },'Ultra Rare':                { label: 'Ultra Rare',cls: 'cwcr-badge-ur',pri: 4,abbr:'UR' },'Ultra rare':                { label: 'Ultra Rare',cls: 'cwcr-badge-ur',pri: 4,abbr:'UR' },'Double Rare':               { label: 'Double Rare',cls: 'cwcr-badge-ur',pri: 5,abbr:'RR' },'Double rare':               { label: 'Double Rare',cls: 'cwcr-badge-ur',pri: 5,abbr:'RR' },'Black White Rare':          { label: 'Black White Rare',cls: 'cwcr-badge-ur',pri: 4,abbr:'BWR' },'Rare Holo':              { label: 'Rare Holo',cls: 'cwcr-badge-ir',pri: 6,abbr:'Holo' },'Rare Holo EX':           { label: 'Rare Holo EX',cls: 'cwcr-badge-ur',pri: 5,abbr:'EX' },'Rare Holo GX':           { label: 'Rare Holo GX',cls: 'cwcr-badge-ur',pri: 5,abbr:'GX' },'Rare Holo V':            { label: 'Rare Holo V',cls: 'cwcr-badge-ur',pri: 5,abbr:'V' },'Rare VMAX':              { label: 'Rare VMAX',cls: 'cwcr-badge-ur',pri: 4,abbr:'VMAX' },'Rare VSTAR':             { label: 'Rare VSTAR',cls: 'cwcr-badge-ur',pri: 4,abbr:'VSTAR' },'Amazing Rare':           { label: 'Amazing Rare',cls: 'cwcr-badge-ir',pri: 4,abbr:'AR' },'Radiant Rare':           { label: 'Radiant Rare',cls: 'cwcr-badge-ir',pri: 4,abbr:'RAD' },'Rare Rainbow':           { label: 'Rainbow Rare',cls: 'cwcr-badge-sir',pri: 2,abbr:'RBW' },'Rare Secret':            { label: 'Secret Rare',cls: 'cwcr-badge-sec',pri: 1,abbr:'SEC' },'Rare Ultra':             { label: 'Ultra Rare',cls: 'cwcr-badge-ur',pri: 4,abbr:'UR' },'Rare Prism Star':        { label: 'Prism Star Rare',cls: 'cwcr-badge-ir',pri: 3,abbr:'PRZ' },'Rare Shiny V':           { label: 'Shiny V Rare',cls: 'cwcr-badge-sar',pri: 2,abbr:'ShV' },'Rare Shiny Holo':        { label: 'Shiny Holo Rare',cls: 'cwcr-badge-ir',pri: 3,abbr:'Shiny' },'Rare BREAK':             { label: 'Rare BREAK',cls: 'cwcr-badge-ir',pri: 5,abbr:'BRK' },'Rare Prime':             { label: 'Rare Prime',cls: 'cwcr-badge-ur',pri: 5,abbr:'PRM' },'Rare Holo Star':         { label: 'Rare Holo Star',cls: 'cwcr-badge-hr',pri: 2,abbr:'Star' },'LEGEND':                 { label: 'LEGEND',cls: 'cwcr-badge-sec',pri: 1,abbr:'LGD' },'Rare Holo LV.X':         { label: 'Rare LV.X',cls: 'cwcr-badge-hr',pri: 2,abbr:'LV.X' },'Trainer Gallery Rare Holo': { label: 'Trainer Gallery Holo',cls: 'cwcr-badge-ir',pri: 3,abbr:'TG' },'Common':{ label:'Common',cls:'cwcr-badge-other',pri:9,abbr:'C' },'Uncommon':{ label:'Uncommon',cls:'cwcr-badge-other',pri:8,abbr:'UC' },'Rare':{ label:'Rare',cls:'cwcr-badge-ir',pri:7,abbr:'R' },'Promo':{ label:'Promo',cls:'cwcr-badge-sp',pri:3,abbr:'P' }
};
var opRarity={
'SEC': { label: 'Secret Rare',    cls: 'cwcr-badge-sec',   pri: 1, tier: 'top',   abbr: 'SEC' },
'SAR': { label: 'Special Art',    cls: 'cwcr-badge-sar',   pri: 2, tier: 'top',   abbr: 'SAR' },
'SP':  { label: 'SP',             cls: 'cwcr-badge-sp',    pri: 3, tier: 'chase', abbr: 'SP' },
'P':   { label: 'Promo',          cls: 'cwcr-badge-sp',    pri: 3, tier: 'chase', abbr: 'P' },
'SR':  { label: 'Super Rare',     cls: 'cwcr-badge-ur',    pri: 4, tier: 'sr',    abbr: 'SR' },
'L':   { label: 'Leader',         cls: 'cwcr-badge-ur',    pri: 5, tier: 'sr',    abbr: 'L' },
'R':   { label: 'Rare',           cls: 'cwcr-badge-ir',    pri: 6, tier: '',      abbr: 'R' },
'UC':  { label: 'Uncommon',       cls: 'cwcr-badge-other', pri: 8, tier: '',      abbr: 'UC' },
'C':   { label: 'Common',         cls: 'cwcr-badge-other', pri: 9, tier: '',      abbr: 'C' },
'DON': { label: 'DON!!',          cls: 'cwcr-badge-other', pri: 10, tier: '',     abbr: 'DON' },
/* Aliassen: de One Piece API geeft volledige rarity-namen i.p.v. de korte codes hierboven */
'SECRET RARE':   { label: 'Secret Rare',   cls: 'cwcr-badge-sec', pri: 1,  tier: 'top', abbr: 'SEC' },
'Special Rare':  { label: 'Special Rare',  cls: 'cwcr-badge-sar', pri: 2,  tier: 'top', abbr: 'SPR' },
'Alternate Art': { label: 'Alternate Art', cls: 'cwcr-badge-sar', pri: 2,  tier: 'top', abbr: 'AA' },
'Treasure Rare': { label: 'Treasure Rare', cls: 'cwcr-badge-sar', pri: 2,  tier: 'top', abbr: 'TR' },
'Manga Rare':    { label: 'Manga Rare',    cls: 'cwcr-badge-sir', pri: 2,  tier: 'manga', abbr: 'MR' },
'SUPER RARE':    { label: 'Super Rare',    cls: 'cwcr-badge-ur',  pri: 4,  tier: 'sr',  abbr: 'SR' },
'LEADER':        { label: 'Leader',        cls: 'cwcr-badge-ur',  pri: 5,  tier: 'sr',  abbr: 'L' },
'rare':          { label: 'Rare',          cls: 'cwcr-badge-ir',  pri: 6,  tier: '',    abbr: 'R' },
'Rare':          { label: 'Rare',          cls: 'cwcr-badge-ir',  pri: 6,  tier: '',    abbr: 'R' },
'Uncommon':      { label: 'Uncommon',      cls: 'cwcr-badge-other', pri: 8,  tier: '',  abbr: 'UC' },
'Common':        { label: 'Common',        cls: 'cwcr-badge-other', pri: 9,  tier: '',  abbr: 'C' },
'DON!!':         { label: 'DON!!',         cls: 'cwcr-badge-other', pri: 10, tier: '',  abbr: 'DON' }
};
/* Cardmarket-links uit de kaartdata: enkel een numeriek id of een https-URL op www.cardmarket.com, anders de zoek-URL */
var CM_OK=/^https:\/\/www\.cardmarket\.com\//;
function cmIdOf(c){ var v=c && (c.cardmarket_id || (c.cardmarket && c.cardmarket.id)); return /^\d+$/.test(String(v||'')) ? String(v) : ''; }
function opCardmarkUrl(c,cardId,name){
  var cmId=cmIdOf(c);
  if(cmId) return 'https://www.cardmarket.com/en/OnePiece/Products?idProduct=' + cmId;
  if(c && CM_OK.test(c.cardmarket_url||'')) return c.cardmarket_url;
  var q=cardId || name || '';
  if(!q) return '';
  return 'https://www.cardmarket.com/en/OnePiece/Products/Search?searchString=' + encodeURIComponent(q);
}
function pkCardmarkUrl(c,name){
  var cmId=cmIdOf(c);
  if(cmId) return 'https://www.cardmarket.com/en/Pokemon/Products?idProduct=' + cmId;
  if(c && c.cardmarket && CM_OK.test(c.cardmarket.url||'')) return c.cardmarket.url;
  if(c && CM_OK.test(c.cardmarket_url||'')) return c.cardmarket_url;
  return 'https://www.cardmarket.com/en/Pokemon/Products/Search?searchString=' + encodeURIComponent(name || (c && c.name) || '');
}
/* Slug identiek aan openCardDetail / _cwcrBuildShareData (en server.js _pdCardSlug) */
function cardSlug(card, isOp){
  var name=isOp?(card.name||card.card_name||''):(card.name||'');
  var number=isOp?(card.card_id||card.id||''):(card.number||'');
  var namePart=(name||'').toLowerCase().replace(/[.\s]+/g,'-').replace(/[^a-z0-9-]/g,'').replace(/-+/g,'-').replace(/^-|-$/g,'');
  var numPart=(number||'').toLowerCase().replace(/[^a-z0-9-]/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
  var cmPart=isOp&&card.cardmarket_id?String(card.cardmarket_id):'';
  return (namePart+(numPart?'-'+numPart:'')+(cmPart?'-'+cmPart:'')).slice(0,80)||'kaart';
}

/* ---------- Momentopname ---------- */
var DATA=null;
function data(){
  if(DATA) return DATA;
  try{
    var el=document.getElementById('pricedex-cards');
    DATA=el ? JSON.parse(el.textContent||'{}') : null;
  }catch(e){ DATA=null; }
  return DATA||{};
}
/* Zet de afgeleide velden die fetchPokemon / fetchOnePiece in cw-pricedex.js op elke kaart zetten */
function prepareCard(entry, k){
  var card=JSON.parse(JSON.stringify(entry.card||{}));
  var fr=entry.franchise==='onepiece'?'onepiece':'pokemon';
  var setId=String(k||'').split('|')[1]||'';
  if(fr==='pokemon'){
    var cp=card.cardmarket && card.cardmarket.prices ? card.cardmarket.prices : null;
    var cmPrice=cwcrCmPrice(cp);
    var tp=card.tcgplayer && card.tcgplayer.prices ? card.tcgplayer.prices : null;
    var tcgPrice=tp ? (
      (tp.holofoil && (tp.holofoil.market || tp.holofoil.mid)) ||
      (tp.normal && (tp.normal.market || tp.normal.mid)) ||
      0
    ) * 0.92 : 0;
    card._price = cmPrice || tcgPrice || 0;
  }else{
    card._price = parseFloat(card.price || card.market_price || card.value || 0) || 0;
    card._setId = card._setId || setId;
  }
  return { card: card, franchise: fr, setId: setId };
}

/* ---------- Toestand (vervangt de window._cwcr*-globals van het origineel) ---------- */
var inited=false;
var navFn=null; /* 15 okt: open(k, live, { nav:fn }) = bladeren met pijltjes en swipen; fn(+1|-1) geeft { k, live } van de volgende kaart */
var hideShop=false; /* open(k, live, { hideShop:true }): geen shopknop (vanuit de Rip Lab) */
var detailOverlay=null, detailClose=null;
var openState=false;
var curCard=null, curFranchise=null, curSetId='';
var nmScope='world';
var lastDetailData=null;
var resetFlip=null, resetZoom=null;
var countUpRAFs=[];
var chartData=null;
var chartSym='€';
var prevBodyOverflow=null;
var openedAt=0; /* tijdstip van openen: een late popstate van een eerdere history.back() mag de verse pop-up niet sluiten */
/* 16 okt (Andrea: "op desktop sluit Terug de pop-up EN verlaat Chase"): de pop-up krijgt een eigen history-entry met dezelfde URL
   (geen hashchange, de Clean-laag ziet geen andere manier). histTok = sleutel van die entry zolang ze de huidige is, histBack = onze
   eigen history.back() na sluiten met X, Escape of klik ernaast loopt nog (de popstate daarvan is van ons, niet van de pagina). */
var histTok=null, histBack=false, histBackT=0;
var $=function(id){ return document.getElementById(id); };

/* ---------- Kaart tilt + holo (zelfde waarden als het origineel) ---------- */
function bindTilt(){
  var imgCol=$('cwcr-detail-img-col');
  var img=$('cwcr-detail-img');
  if(!imgCol || !img) return;
  var MAX_TILT=12;
  var resetTimer=null;
  imgCol.addEventListener('mousemove',function(e){
    var rect=imgCol.getBoundingClientRect();
    var x=(e.clientX - rect.left) / rect.width  - 0.5;
    var y=(e.clientY - rect.top)  / rect.height - 0.5;
    var rotY= x * MAX_TILT * 2;
    var rotX=-y * MAX_TILT;
    img.style.transform = 'perspective(800px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) scale(1.04)';
    clearTimeout(resetTimer);
  });
  imgCol.addEventListener('mouseleave',function(){
    img.style.transition = 'transform 0.6s ease,box-shadow 0.15s ease';
    img.style.transform = '';
    resetTimer = setTimeout(function(){ img.style.transition = ''; },650);
  });
  imgCol.addEventListener('mouseenter',function(){
    img.style.transition = 'transform 0.1s ease,box-shadow 0.15s ease';
  });
}
function bindHolo(){
  var imgCol=$('cwcr-detail-img-col');
  var imgWrap=$('cwcr-card-img-wrap');
  if(!imgCol || !imgWrap) return;
  imgCol.addEventListener('mousemove',function(e){
    var rect=imgWrap.getBoundingClientRect();
    if(rect.width===0) return;
    var px=Math.max(0,Math.min(1,(e.clientX - rect.left) / rect.width));
    var py=Math.max(0,Math.min(1,(e.clientY - rect.top)  / rect.height));
    var angle=(Math.atan2(py - 0.5,px - 0.5) * (180 / Math.PI)).toFixed(1) + 'deg';
    imgWrap.style.setProperty('--holo-x',(px * 100).toFixed(1) + '%');
    imgWrap.style.setProperty('--holo-y',(py * 100).toFixed(1) + '%');
    imgWrap.style.setProperty('--holo-angle',angle);
  });
  imgCol.addEventListener('mouseleave',function(){
    imgWrap.style.setProperty('--holo-x','50%');
    imgWrap.style.setProperty('--holo-y','50%');
    imgWrap.style.setProperty('--holo-angle','135deg');
  });
}
/* ---------- Zoom ---------- */
function bindZoom(){
  var zoomBtn=$('cwcr-zoom-btn');
  var imgEl=$('cwcr-detail-img');
  var imgWrap=$('cwcr-card-img-wrap');
  var imgColEl=$('cwcr-detail-img-col');
  if(!zoomBtn || !imgColEl) return;
  var isZoomed=false;
  function toggleZoom(){
    isZoomed = !isZoomed;
    imgColEl.classList.toggle('cwcr-img-zoomed',isZoomed);
    zoomBtn.classList.toggle('cwcr-ctrl-active',isZoomed);
  }
  var clickTarget=imgWrap || imgEl;
  if(clickTarget) clickTarget.addEventListener('click',function(e){ e.stopPropagation(); toggleZoom(); });
  zoomBtn.addEventListener('click',function(e){ e.stopPropagation(); toggleZoom(); });
  imgColEl.addEventListener('click',function(e){
    if(isZoomed && !(imgWrap ? e.target.closest('#cwcr-card-img-wrap') : e.target.closest('#cwcr-detail-img'))) toggleZoom();
  });
  resetZoom = function(){
    if(!isZoomed) return;
    isZoomed=false;
    imgColEl.classList.remove('cwcr-img-zoomed');
    zoomBtn.classList.remove('cwcr-ctrl-active');
  };
}
/* ---------- Flip naar kaartinfo ---------- */
function bindFlip(){
  var flipBtn=$('cwcr-flip-btn');
  var flipper=$('cwcr-card-flipper');
  if(!flipBtn || !flipper) return;
  var isFlipped=false;
  flipBtn.addEventListener('click',function(){
    isFlipped = !isFlipped;
    flipper.style.transform = isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)';
    flipper.classList.toggle('cwcr-is-flipped',isFlipped);
    flipBtn.classList.toggle('cwcr-ctrl-active',isFlipped);
  });
  resetFlip = function(){
    if(!isFlipped) return;
    isFlipped=false;
    flipper.style.transform = 'rotateY(0deg)';
    flipper.classList.remove('cwcr-is-flipped');
    flipBtn.classList.remove('cwcr-ctrl-active');
  };
}

/* ---------- Aura-vonken rond de kaart ---------- */
function cwcrUpdateAura(tier){
  var sparksEl=$('cwcr-aura-sparks');
  if(sparksEl) sparksEl.innerHTML = '';
  if(tier<3 || !sparksEl) return;
  var rnd=function(a,b){ return a + Math.random() * (b - a); };
  var sparkCfg={
    3: { count:4,colors:['rgba(70,145,255,0.9)','rgba(140,195,255,0.8)','rgba(210,230,255,0.85)'],minDist:62,maxDist:112,minLen:12,maxLen:22,minSpd:0.65,maxSpd:1.0 },
    4: { count:7,colors:['rgba(255,208,50,0.95)','rgba(255,235,105,0.88)','#fff','rgba(255,162,0,0.9)'],minDist:74,maxDist:132,minLen:14,maxLen:28,minSpd:0.55,maxSpd:0.95 },
    5: { count:11,colors:['rgba(180,100,255,0.9)','rgba(80,185,255,0.85)','#fff','rgba(255,80,175,0.88)','rgba(105,255,200,0.85)','rgba(255,235,65,0.9)'],minDist:80,maxDist:145,minLen:14,maxLen:30,minSpd:0.5,maxSpd:0.88 }
  };
  var sc=sparkCfg[tier] || sparkCfg[3];
  for(var si=0; si<sc.count; si++){
    var angle=(2 * Math.PI / sc.count) * si + (Math.random() - 0.5) * 0.5;
    var dist=rnd(sc.minDist,sc.maxDist);
    var cx=Math.cos(angle) * dist;
    var cy=Math.sin(angle) * dist;
    var sparkRot=angle * 180 / Math.PI + 90;
    var color=sc.colors[Math.floor(Math.random() * sc.colors.length)];
    var wrap=document.createElement('div');
    wrap.className = 'cwcr-spark';
    wrap.style.cssText = 'left:50%;top:50%;transform:translate(calc(-50% + '+cx.toFixed(1)+'px),calc(-50% + '+cy.toFixed(1)+'px)) rotate('+sparkRot.toFixed(1)+'deg)';
    var bar=document.createElement('div');
    bar.className = 'cwcr-spark-bar';
    bar.style.cssText = '--sw:'+rnd(1.5,2.4).toFixed(1)+'px;--sh:'+rnd(sc.minLen,sc.maxLen).toFixed(1)+'px;--ss:'+rnd(sc.minSpd,sc.maxSpd).toFixed(2)+'s;--sdel:'+(-rnd(0,sc.maxSpd)).toFixed(2)+'s;--sc:'+color;
    wrap.appendChild(bar);
    sparksEl.appendChild(wrap);
  }
}

/* ---------- Tabs ---------- */
function cwcrInitTabs(){
  var nav=$('cwcr-tab-nav');
  if(!nav) return;
  nav.querySelectorAll('.cwcr-tab-btn').forEach(function(btn){
    btn.onclick = function(){ cwcrSwitchTab(btn.dataset.tab); };
  });
}
function cwcrSwitchTab(tabName){
  detailOverlay.querySelectorAll('.cwcr-tab-btn').forEach(function(b){
    b.classList.toggle('is-active',b.dataset.tab===tabName);
  });
  detailOverlay.querySelectorAll('.cwcr-tab-panel').forEach(function(p){
    var id=p.id.replace('cwcr-panel-','');
    if(id===tabName){
      /* Safari fix van het origineel: eindstate inline forceren bij heropenen */
      p.classList.add('is-active');
      p.style.animation='none';
      p.style.opacity='1';
      p.style.transform='none';
    } else {
      p.classList.remove('is-active');
      p.style.animation='';
      p.style.opacity='';
      p.style.transform='';
    }
  });
}

/* ---------- Count-up animaties ---------- */
function cwcrCancelAllCountUps(){
  countUpRAFs.forEach(function(id){ try{ cancelAnimationFrame(id); }catch(e){} });
  countUpRAFs=[];
}
function cwcrCountUp(el,target,duration,sym){
  if(!el || !target || target<=0) return;
  sym=sym||'€';
  duration = duration || 600;
  if(el._cwcrRafId){ try{ cancelAnimationFrame(el._cwcrRafId); }catch(e){} el._cwcrRafId=null; }
  var start=0,startTime=null;
  function step(ts){
    if(!startTime) startTime = ts;
    var progress=Math.min((ts - startTime) / duration,1);
    var ease=1 - Math.pow(1 - progress,3);
    var current=start + (target - start) * ease;
    el.textContent = money(current,sym);
    if(progress<1){
      el._cwcrRafId = requestAnimationFrame(step);
      countUpRAFs.push(el._cwcrRafId);
    } else {
      el._cwcrRafId = null;
    }
  }
  el._cwcrRafId = requestAnimationFrame(step);
  countUpRAFs.push(el._cwcrRafId);
}

/* Vlag-emoji per ISO-2 code (15 okt: niet meer gebruikt in klanttekst, geen emoji in de site-UI) */
function cwcrFlag(code){
  if(!code || code.length!==2) return '';
  var A=0x1F1E6, ASCII_A=65;
  return String.fromCodePoint(A + (code.charCodeAt(0) - ASCII_A)) + String.fromCodePoint(A + (code.charCodeAt(1) - ASCII_A));
}
var countryNames={ DE: 'Duitsland',FR: 'Frankrijk',ES: 'Spanje',IT: 'Italië',NL: 'Nederland',BE: 'België',AT: 'Oostenrijk',PL: 'Polen',PT: 'Portugal',GB: 'UK',IE: 'Ierland',DK: 'Denemarken',SE: 'Zweden',FI: 'Finland',NO: 'Noorwegen',CZ: 'Tsjechië',GR: 'Griekenland',HU: 'Hongarije',RO: 'Roemenië' };

/* ---------- Tab Overzicht ---------- */
function cwcrFillOverzicht(d,skipAnim){
  var T=I18N;
  var heroEl=$('cwcr-price-hero');
  var pricesEl=$('cwcr-detail-prices');
  var evoRowEl=$('cwcr-evo-row');
  if(!heroEl || !pricesEl || !evoRowEl) return;
  var sym=d.sym||'€';
  var isUsd=d.currency==='USD';
  var hasNmWorld=d.nmPrice>0;
  var hasNmEU=d.nmEU>0;
  var countryMap=d.nmByCountry || {};
  var countryCodes=Object.keys(countryMap).filter(function(k){ return countryMap[k]>0; }).sort();
  var scope=nmScope || 'world';
  if(scope==='world' && !hasNmWorld) scope=hasNmEU ? 'eu' : (countryCodes[0] ? 'c:'+countryCodes[0] : 'none');
  else if(scope==='eu' && !hasNmEU) scope=hasNmWorld ? 'world' : (countryCodes[0] ? 'c:'+countryCodes[0] : 'none');
  else if(scope.indexOf('c:')===0){
    var cc=scope.slice(2);
    if(!(countryMap[cc]>0)) scope=hasNmWorld ? 'world' : (hasNmEU ? 'eu' : 'none');
  }
  var heroPrice=d.price,heroLabel=(T.currentPrice||'Huidige prijs');
  if(scope==='world'){ heroPrice=d.nmPrice; heroLabel=isUsd?(T.tcgMarketPrice||'TCGplayer Richtprijs'):(T.nmWorldwide||'Near Mint (Wereldwijd)'); }
  else if(scope==='eu'){ heroPrice=d.nmEU; heroLabel=(T.nmEU||'Near Mint (EU)'); }
  else if(scope.indexOf('c:')===0){
    var code=scope.slice(2);
    heroPrice=countryMap[code];
    heroLabel='Near Mint ' + countryName(code);
  }
  var toggleHtml='';
  var toggleBtns=[];
  if(hasNmWorld) toggleBtns.push({ scope: 'world',label: (T.world||'Wereld'),title: (T.allSellers||'Alle Cardmarket sellers wereldwijd') });
  if(hasNmEU)    toggleBtns.push({ scope: 'eu',label: (T.euBtn||'EU'),title: (T.onlyEuSellers||'Alleen EU sellers') });
  countryCodes.forEach(function(cc){
    toggleBtns.push({ scope: 'c:'+cc,label: cc,title: countryName(cc) + ' '+(T.sellers||'sellers') });
  });
  if(toggleBtns.length>1){
    toggleHtml = '<div class="cwcr-nm-scope-toggle" role="tablist" aria-label="'+(T.nmRegion||'Near Mint regio')+'">';
    toggleBtns.forEach(function(b){
      toggleHtml += '<button type="button" class="cwcr-nm-scope-btn' + (scope===b.scope ? ' is-active' : '') + '" title="' + esc(b.title) + '" data-pdxm-scope="' + b.scope + '">' + b.label + '</button>';
    });
    toggleHtml += '</div>';
  }
  heroEl.innerHTML = toggleHtml +
    (isUsd ? '<div class="cwcr-price-hero-usd" title="'+(T.usdMarketNotAvailable||'USD via TCGplayer - EU marktdata niet beschikbaar')+'">'+(T.usdViaTcg||'USD via TCGplayer')+'</div>' : '') +
    '<div class="cwcr-price-hero-label">' + heroLabel + '</div>' +
    '<div class="cwcr-price-hero-value" id="cwcr-hero-val">'+money(0,sym)+'</div>' +
    (scope!=='none' && d.low>0 ? '<div class="cwcr-price-hero-sub">'+(T.lowest||'Laagste')+': '+money(d.low,sym)+'</div>' : '');
  var heroValEl=$('cwcr-hero-val');
  if(heroValEl && heroPrice>0){
    if(skipAnim){ heroValEl.textContent = money(heroPrice,sym); }
    else { cwcrCountUp(heroValEl,heroPrice,700,sym); }
  }
  lastDetailData=d;
  var cells=[];
  if(d.avg1>0)  cells.push({ label: (T.avg1d||'Gem. 1D'),val: d.avg1 });
  if(d.avg7>0)  cells.push({ label: (T.avg7d||'Gem. 7D'),val: d.avg7 });
  if(d.avg30>0) cells.push({ label: (T.avg30d||'Gem. 30D'),val: d.avg30 });
  if(d.trend>0) cells.push({ label: (T.trend||'Trend'),val: d.trend });
  if(d.low>0)   cells.push({ label: (T.lowest||'Laagste'),val: d.low });
  if(d.avgSell>0 && d.avgSell!==d.trend) cells.push({ label: (T.avgSale||'Gem. Verkoop'),val: d.avgSell });
  if(cells.length>0){
    var ph='';
    cells.forEach(function(c,i){
      ph += '<div class="cwcr-detail-price-cell"><div class="cwcr-detail-price-label">' + c.label + '</div>' +
        '<div class="cwcr-detail-price-val cwcr-detail-price-muted" id="cwcr-price-cell-' + i + '">'+money(0,sym)+'</div></div>';
    });
    pricesEl.innerHTML = ph;
    cells.forEach(function(c,i){
      var el=$('cwcr-price-cell-' + i);
      if(!el) return;
      if(skipAnim){ el.textContent=money(c.val,sym); }
      else cwcrCountUp(el,c.val,500 + i * 80,sym);
    });
  }else{
    pricesEl.innerHTML = '<div style="color:rgba(255,255,255,0.25);font-size:12px;grid-column:1/-1">'+(T.noPriceData||'Geen prijsdata beschikbaar')+'</div>';
  }
  var evoHtml='';
  function evoBadge(label,val){
    if(val == null) return '';
    var cls=val>0 ? 'cwcr-evo-up' : val<0 ? 'cwcr-evo-down' : 'cwcr-evo-flat';
    var sign=val>0 ? '+' : '';
    return '<div class="cwcr-evo-badge ' + cls + '"><span class="cwcr-evo-badge-label">' + label + '</span> ' + pct(val,true) + '</div>';
  }
  if(d.evo){
    /* Verse set: alle termijnen -100% betekent "nog geen referentie", geen crash */
    var _ev=[d.evo.rawEvo1,d.evo.rawEvo7,d.evo.rawEvo30].filter(function(v){return v!=null;});
    var _allM100=_ev.length>0 && _ev.every(function(v){return v<=-99.9;});
    if(_allM100){
      evoHtml='<div class="cwcr-evo-nodata" style="grid-column:1/-1;padding:9px 13px;border-radius:11px;background:rgba(123,94,167,0.07);border:1px solid rgba(123,94,167,0.15);color:#6b5a8a;font-size:12.5px;line-height:1.4;display:flex;align-items:center;gap:7px;"><span>'+(T.evoNoData||'Nog niet genoeg prijsdata voor deze nieuwe set')+'</span></div>';
    }else{
      evoHtml += evoBadge(T.d1,d.evo.rawEvo1);
      evoHtml += evoBadge(T.d7,d.evo.rawEvo7);
      evoHtml += evoBadge(T.d30,d.evo.rawEvo30);
    }
  }
  evoRowEl.innerHTML = evoHtml;
  var nmEvoRowEl=$('cwcr-nm-evo-row');
  if(nmEvoRowEl){
    var nmEvo=d.evo || {};
    var d1=nmEvo.calculatedDay1Pct!=null ? nmEvo.calculatedDay1Pct : null;
    var d7=nmEvo.calculatedDay7Pct!=null ? nmEvo.calculatedDay7Pct : null;
    var d30=nmEvo.calculatedDay30Pct!=null ? nmEvo.calculatedDay30Pct : null;
    var nmTitleEl=nmEvoRowEl.previousElementSibling;
    var allNull=d1==null && d7==null && d30==null;
    var allZero=!allNull && d1===0 && d7===0 && d30===0;
    if(allNull || allZero){
      nmEvoRowEl.innerHTML='';
      if(nmTitleEl) nmTitleEl.style.display='none';
    }else{
      if(nmTitleEl) nmTitleEl.style.display='';
      var nmEvoHtml='';
      nmEvoHtml+=evoBadge(T.d1,d1);
      nmEvoHtml+=evoBadge(T.d7,d7);
      nmEvoHtml+=evoBadge(T.d30,d30);
      nmEvoRowEl.innerHTML=nmEvoHtml;
    }
  }
}
function cwcrSetNmScope(scope){
  nmScope=scope;
  if(lastDetailData) cwcrFillOverzicht(lastDetailData,true);
}

/* ---------- Tab Prijsanalyse ---------- */
function cwcrFillAnalyse(d){
  var T=I18N;
  var periodsEl=$('cwcr-chart-periods');
  var chartEl=$('cwcr-detail-chart');
  var tableEl=$('cwcr-price-table');
  if(!periodsEl || !chartEl || !tableEl) return;
  var sym=d.sym||'€';
  var isUsd=d.currency==='USD';
  /* 1. Tijdlijn voor de lijngrafiek */
  var allPoints=[];
  if(d.avg30>0) allPoints.push({ label:(T.thirtyDay||'30D gem'),val:d.avg30,isCurrent:false,period:30 });
  if(d.avg7 >0) allPoints.push({ label:(T.sevenDay||'7D gem'), val:d.avg7, isCurrent:false,period:7  });
  if(!d.isOp && d.avg1>0) allPoints.push({ label:(T.oneDay||'1D gem'),val:d.avg1,isCurrent:false,period:1 });
  if(d.price>0) allPoints.push({ label:(T.now||'Nu'),val:d.price,isCurrent:true,period:0 });
  if(!d.isOp && allPoints.length<2 && d.trend>0 && d.price>0){
    allPoints=[{ label:(T.trend||'Trend'),val:d.trend,isCurrent:false,period:30 },{ label:(T.now||'Nu'),val:d.price,isCurrent:true,period:0 }];
  }
  if(allPoints.length===1 && allPoints[0].val>0){
    allPoints.unshift({ label:(T.ref||'Ref'),val:allPoints[0].val,isCurrent:false,period:30 });
  }
  chartData=allPoints;
  /* 2. Prijs-hero boven de periodeknoppen */
  var heroPrice=d.price>0 ? money(d.price,sym) : (d.nmPrice>0 ? money(d.nmPrice,sym) : '-');
  var existingHero=periodsEl.parentNode.querySelector('.cwcr-analyse-hero');
  if(existingHero) existingHero.parentNode.removeChild(existingHero);
  var heroDiv=document.createElement('div');
  heroDiv.className='cwcr-analyse-hero';
  heroDiv.innerHTML='<div class="cwcr-analyse-hero-price">'+heroPrice+'</div><div class="cwcr-analyse-hero-label">'+(T.nearMintPrice||'Near Mint Prijs')+'</div>';
  periodsEl.parentNode.insertBefore(heroDiv,periodsEl);
  /* Periodeknoppen */
  var periods=[{ label:T.d1,max:2 },{ label:T.d7,max:8 },{ label:T.d30,max:31 }];
  var pHtml='';
  periods.forEach(function(p){
    pHtml+='<button type="button" class="cwcr-chart-period-btn'+(p.max===2?' is-active':'')+'" data-max="'+p.max+'" data-pdxm-period="'+p.max+'">'+p.label+'</button>';
  });
  periodsEl.innerHTML=pHtml;
  /* 3. Lijn-/areagrafiek, standaard met de 1D-filter */
  var initFiltered=allPoints.filter(function(p){ return p.period<2 || p.period===0; });
  if(initFiltered.length<2 && allPoints.length>=2) initFiltered=allPoints;
  chartSym=sym;
  cwcrRenderChart(initFiltered,chartEl,sym);
  if(isUsd && chartEl){ chartEl.insertAdjacentHTML('afterbegin','<div class="cwcr-price-hero-usd" style="margin-bottom:8px">'+esc(I18N.usdNoChart)+'</div>'); }
  /* 4. KPI-pillen 1D / 7D / 30D */
  var kpiDefs=[
    { label:T.d1, evo: d.evo && d.evo.rawEvo1!=null ? d.evo.rawEvo1 : null, ref:d.avg1, cur:d.price },
    { label:T.d7, evo: d.evo && d.evo.rawEvo7!=null ? d.evo.rawEvo7 : null, ref:d.avg7, cur:d.price },
    { label:T.d30,evo: d.evo && d.evo.rawEvo30!=null ? d.evo.rawEvo30 : null, ref:d.avg30,cur:d.price }
  ];
  var kpiHtml='<div class="cwcr-detail-chart-title" style="margin-top:8px">'+(T.evoAllConditions||'Evolutie Alle Condities')+'</div>';
  var _evoVals=kpiDefs.map(function(k){return k.evo;}).filter(function(v){return v!=null;});
  var _hasRef=kpiDefs.some(function(k){return k.ref>0;});
  var _allMinus100=_evoVals.length>0 && _evoVals.every(function(v){return v<=-99.9;}) && !_hasRef;
  if(_allMinus100){
    kpiHtml+='<div class="cwcr-evo-nodata" style="margin-top:6px;padding:10px 14px;border-radius:12px;background:rgba(123,94,167,0.07);border:1px solid rgba(123,94,167,0.15);color:#6b5a8a;font-size:13px;line-height:1.45;display:flex;align-items:center;gap:8px;"><span>'+(T.evoNoData||'Nog niet genoeg prijsdata voor deze nieuwe set')+'</span></div>';
  } else {
    kpiHtml+='<div class="cwcr-kpi-row">';
    kpiDefs.forEach(function(k){
      var pctStr='-', pctCls='cwcr-val-muted', deltaStr='';
      if(k.evo!=null){
        pctCls=k.evo>0?'cwcr-val-green':k.evo<0?'cwcr-val-red':'cwcr-val-muted';
        pctStr=pct(k.evo,true);
      }
      if(k.ref>0 && k.cur>0){
        var delta=k.cur - k.ref;
        deltaStr=(delta>=0?'+':'-')+money(Math.abs(delta),sym);
      }
      kpiHtml+='<div class="cwcr-kpi-pill">';
      kpiHtml+='<div class="cwcr-kpi-label">'+k.label+'</div>';
      kpiHtml+='<div class="cwcr-kpi-pct '+pctCls+'">'+pctStr+'</div>';
      kpiHtml+='<div class="cwcr-kpi-delta">'+deltaStr+'</div>';
      kpiHtml+='</div>';
    });
    kpiHtml+='</div>';
  }
  /* 4b. Near-Mint evolutie */
  var nmEvo=d.evo||{};
  var nmD1=nmEvo.calculatedDay1Pct!=null?nmEvo.calculatedDay1Pct:null;
  var nmD7=nmEvo.calculatedDay7Pct!=null?nmEvo.calculatedDay7Pct:null;
  var nmD30=nmEvo.calculatedDay30Pct!=null?nmEvo.calculatedDay30Pct:null;
  var _nmHasNonZero=(nmD1!=null&&nmD1!==0)||(nmD7!=null&&nmD7!==0)||(nmD30!=null&&nmD30!==0);
  if(_nmHasNonZero){
    var nmKpiDefs=[{ label:T.d1, evo:nmD1 },{ label:T.d7, evo:nmD7 },{ label:T.d30,evo:nmD30 }];
    kpiHtml+='<div class="cwcr-detail-chart-title" style="margin-top:10px">'+(T.evoNearMint||'Prijsevolutie Near Mint')+'</div><div class="cwcr-kpi-row">';
    nmKpiDefs.forEach(function(k){
      var pctStr='-', pctCls='cwcr-val-muted';
      if(k.evo!=null){
        pctCls=k.evo>0?'cwcr-val-green':k.evo<0?'cwcr-val-red':'cwcr-val-muted';
        pctStr=pct(k.evo,true);
      }
      kpiHtml+='<div class="cwcr-kpi-pill">';
      kpiHtml+='<div class="cwcr-kpi-label">'+k.label+'</div>';
      kpiHtml+='<div class="cwcr-kpi-pct '+pctCls+'">'+pctStr+'</div>';
      kpiHtml+='</div>';
    });
    kpiHtml+='</div>';
  }
  var barHtml=kpiHtml;
  /* 5. Gegroepeerde, inklapbare prijstabel */
  var nmRows=[];
  if(d.nmPrice>0) nmRows.push({ label:(T.worldwide||'Wereldwijd'),val:money(d.nmPrice,sym),cls:'cwcr-val-gold' });
  if(d.nmEU>0)    nmRows.push({ label:(T.europe||'Europa'),val:money(d.nmEU,sym),cls:'' });
  if(d.nmByCountry){ Object.keys(d.nmByCountry).sort().forEach(function(cc){ var v=d.nmByCountry[cc]; if(v>0) nmRows.push({ label:countryName(cc),val:money(v,sym),cls:'' }); }); }
  var avgRows=[];
  if(d.avgSell>0) avgRows.push({ label:(T.avgSalePrice||'Gem. Verkoopprijs'),val:money(d.avgSell,sym) });
  if(d.trend>0)   avgRows.push({ label:(T.trendPrice||'Trendprijs'),val:money(d.trend,sym) });
  if(d.low>0)     avgRows.push({ label:(T.lowestPrice||'Voordeligst'),val:money(d.low,sym) });
  if(d.avg1>0)    avgRows.push({ label:(T.average1d||'Gemiddelde 1D'),val:money(d.avg1,sym) });
  if(d.avg7>0)    avgRows.push({ label:(T.average7d||'Gemiddelde 7D'),val:money(d.avg7,sym) });
  if(d.avg30>0)   avgRows.push({ label:(T.average30d||'Gemiddelde 30D'),val:money(d.avg30,sym) });
  var evoRows=[];
  if(d.evo && !_allMinus100){
    var _ecls=function(v){ return v>0?'cwcr-val-green':v<0?'cwcr-val-red':''; };
    var _eval=function(v){ return pct(v,true); };
    if(d.evo.rawEvo1 !=null) evoRows.push({ label:(T.evo1d||'Evolutie 1D'), val:_eval(d.evo.rawEvo1), cls:_ecls(d.evo.rawEvo1)  });
    if(d.evo.rawEvo7 !=null) evoRows.push({ label:(T.evo7d||'Evolutie 7D'), val:_eval(d.evo.rawEvo7), cls:_ecls(d.evo.rawEvo7)  });
    if(d.evo.rawEvo30!=null) evoRows.push({ label:(T.evo30d||'Evolutie 30D'),val:_eval(d.evo.rawEvo30),cls:_ecls(d.evo.rawEvo30) });
  }
  function renderPtSection(title,rows){
    if(!rows.length) return '';
    var rowsH=rows.map(function(r){ return '<div class="cwcr-price-compare-row"><span class="cwcr-price-compare-label">'+r.label+'</span><span class="cwcr-price-compare-val '+(r.cls||'')+'">'+r.val+'</span></div>'; }).join('');
    var chevSvg='<svg class="cwcr-pt-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="13" height="13" style="transition:transform 0.2s;transform:rotate(180deg)"><polyline points="6 9 12 15 18 9"/></svg>';
    return '<div class="cwcr-pt-section">'+
      '<div class="cwcr-pt-section-hdr cwcr-pt-open" data-pdxm-act="pt-section">'+
      '<span>'+title+'</span>'+chevSvg+
      '</div>'+
      '<div class="cwcr-pt-section-body">'+rowsH+'</div>'+
      '</div>';
  }
  var sectionsHtml=renderPtSection((T.nmPrices||'Near Mint prijzen'),nmRows)+renderPtSection((T.priceAverages||'Prijsgemiddelden'),avgRows)+renderPtSection((T.priceEvolution||'Prijsevolutie'),evoRows);
  var toggleChevSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="13" height="13" style="transition:transform 0.2s"><polyline points="6 9 12 15 18 9"/></svg>';
  var tableWrap='<div class="cwcr-pt-wrap">'+
    '<div class="cwcr-pt-toggle" data-pdxm-act="pt-table">'+toggleChevSvg+'<span>'+(T.showFullTable||'Toon volledige prijstabel')+'</span></div>'+
    '<div class="cwcr-pt-inner cwcr-pt-inner-collapsed">'+sectionsHtml+'</div>'+
    '</div>';
  tableEl.innerHTML=barHtml+tableWrap;
}
function cwcrRenderChart(points,container,sym){
  var T=I18N;
  sym=sym||'€';
  if(!container) return;
  var _chLight=IS_LIGHT;
  var _chGrid=_chLight?'rgba(29,19,48,0.08)':'rgba(255,255,255,0.05)';
  var _chYLabel=_chLight?'rgba(29,19,48,0.45)':'rgba(255,255,255,0.25)';
  var _chXLabel=_chLight?'rgba(29,19,48,0.5)':'rgba(255,255,255,0.35)';
  var _chNodeStroke=_chLight?'rgba(255,255,255,0.95)':'rgba(17,5,48,0.9)';
  var _chEmpty=_chLight?'rgba(29,19,48,0.35)':'rgba(255,255,255,0.2)';
  if(!points || points.length<2){
    container.innerHTML = '<div style="text-align:center;padding:40px 0;color:'+_chEmpty+';font-size:12px">'+(T.noChartData||'Geen grafiekdata beschikbaar')+'</div>';
    return;
  }
  var W=700,H = 150,PL = 50,PR = 14,PT = 10,PB = 32;
  var cw=W - PL - PR,ch = H - PT - PB;
  var vals=points.map(function(p){ return p.val; });
  var minV=Math.min.apply(null,vals),maxV = Math.max.apply(null,vals);
  var range=maxV - minV || 0.01;
  var pad=range * 0.08; minV -= pad; maxV += pad; range = maxV - minV;
  var pts=points.map(function(p,i){
    return{ x: PL + (i / (points.length - 1)) * cw,y: PT + ch - ((p.val - minV) / range) * ch,val: p.val,label: p.label,isCurrent: p.isCurrent };
  });
  var nGrid=4;
  var gridSvg='';
  for(var g=0; g<=nGrid; g++){
    var gy=PT + (g / nGrid) * ch;
    var gv=maxV - (g / nGrid) * range;
    gridSvg += '<line x1="' + PL + '" y1="' + gy.toFixed(1) + '" x2="' + (W - PR) + '" y2="' + gy.toFixed(1) + '" stroke="' + _chGrid + '" stroke-width="1"/>';
    gridSvg += '<text x="' + (PL - 6) + '" y="' + (gy + 4).toFixed(1) + '" text-anchor="end" font-size="10" fill="' + _chYLabel + '" font-family="var(--cwcr-font)">' + money(gv,sym) + '</text>';
  }
  var pathD;
  if(pts.length>=4){
    pathD = 'M' + pts[0].x.toFixed(1) + ',' + pts[0].y.toFixed(1);
    for(var i=0; i<pts.length - 1; i++){
      var p0=pts[Math.max(0,i - 1)];
      var p1=pts[i];
      var p2=pts[i + 1];
      var p3=pts[Math.min(pts.length - 1,i + 2)];
      var t=0.3;
      var cp1x=p1.x + (p2.x - p0.x) * t;
      var cp1y=p1.y + (p2.y - p0.y) * t;
      var cp2x=p2.x - (p3.x - p1.x) * t;
      var cp2y=p2.y - (p3.y - p1.y) * t;
      pathD += ' C' + cp1x.toFixed(1) + ',' + cp1y.toFixed(1) + ' ' + cp2x.toFixed(1) + ',' + cp2y.toFixed(1) + ' ' + p2.x.toFixed(1) + ',' + p2.y.toFixed(1);
    }
  }else{
    pathD = pts.map(function(p,i){ return (i===0 ? 'M' : 'L') + p.x.toFixed(1) + ',' + p.y.toFixed(1); }).join(' ');
  }
  var areaD=pathD + ' L' + pts[pts.length-1].x.toFixed(1) + ',' + (H - PB) + ' L' + PL + ',' + (H - PB) + ' Z';
  var xLabels=pts.map(function(p){
    return '<text x="' + p.x.toFixed(1) + '" y="' + (H - 6) + '" text-anchor="middle" font-size="10" fill="' + _chXLabel + '" font-family="var(--cwcr-font)">' + p.label + '</text>';
  }).join('');
  var circles=pts.map(function(p,idx){
    var col=p.isCurrent ? '#E8C840' : '#a78bfa';
    var r=p.isCurrent ? 6 : 4.5;
    return '<g class="cwcr-chart-point" data-label="' + esc(p.label) + '" data-val="' + esc(money(p.val,sym)) + '" data-cx="' + p.x.toFixed(1) + '" style="animation:cwcrPointIn 0.3s ' + (0.3 + idx * 0.08) + 's both">' +
      '<circle cx="' + p.x.toFixed(1) + '" cy="' + p.y.toFixed(1) + '" r="' + (r + 10) + '" fill="transparent"/>' +
      '<circle cx="' + p.x.toFixed(1) + '" cy="' + p.y.toFixed(1) + '" r="' + r + '" fill="' + col + '" stroke="' + _chNodeStroke + '" stroke-width="2.5"/>' +
      (p.isCurrent ? '<circle cx="' + p.x.toFixed(1) + '" cy="' + p.y.toFixed(1) + '" r="10" fill="rgba(232,200,64,0.12)"><animate attributeName="r" values="8;13;8" dur="2.5s" repeatCount="indefinite"/><animate attributeName="opacity" values="0.15;0.04;0.15" dur="2.5s" repeatCount="indefinite"/></circle>' : '') +
      '</g>';
  }).join('');
  var pathLen=0;
  for(var k=1; k<pts.length; k++){
    pathLen += Math.sqrt(Math.pow(pts[k].x - pts[k-1].x,2) + Math.pow(pts[k].y - pts[k-1].y,2));
  }
  pathLen = Math.ceil(pathLen * 1.3);
  container.innerHTML =
    '<div class="cwcr-detail-chart-title">' + esc(T.nmEvoPrices||'Gemiddeld NM prijsverloop') + '</div>' +
    '<div style="position:relative">' +
    '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" style="width:100%;display:block;overflow:visible">' +
    '<defs>' +
    '<linearGradient id="cwcrAreaGrad2" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="rgba(145,70,255,0.25)"/><stop offset="100%" stop-color="rgba(145,70,255,0)"/></linearGradient>' +
    '<style>@keyframes cwcrPointIn{from{opacity:0;transform:scale(0)}to{opacity:1;transform:scale(1)}}@keyframes cwcrPulse{0%,100%{r:10;opacity:0.15}50%{r:14;opacity:0.05}}<\/style>' +
    '</defs>' +
    gridSvg +
    '<path d="' + areaD + '" fill="url(#cwcrAreaGrad2)" style="animation:cwcrChartAreaFade 0.5s 0.2s both"/>' +
    '<path d="' + pathD + '" fill="none" stroke="#9146ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="stroke-dasharray:' + pathLen + ';--cwcr-path-len:' + pathLen + ';animation:cwcrChartDraw 0.8s ease forwards"/>' +
    xLabels + circles +
    '</svg>' +
    '<div class="cwcr-chart-tooltip" id="cwcr-chart-tooltip2"></div>' +
    '</div>';
  container.querySelectorAll('.cwcr-chart-point').forEach(function(pt){
    var tooltip=container.querySelector('#cwcr-chart-tooltip2');
    pt.addEventListener('mouseenter',function(){
      if(!tooltip) return;
      tooltip.textContent = pt.dataset.label + ': ' + pt.dataset.val;
      var ptCircle=pt.querySelector('circle:nth-of-type(2)') || pt.querySelector('circle:last-of-type');
      if(ptCircle){
        var cr=ptCircle.getBoundingClientRect();
        var pr=tooltip.parentElement.getBoundingClientRect();
        tooltip.style.left = (cr.left - pr.left + cr.width / 2) + 'px';
        tooltip.style.top  = (cr.top  - pr.top  + cr.height / 2) + 'px';
      }
      tooltip.style.display='block';
    });
    pt.addEventListener('mouseleave',function(){
      if(tooltip) tooltip.style.display='none';
    });
  });
}
function cwcrFilterChart(maxPeriod,btn){
  if(!chartData) return;
  var filtered=chartData.filter(function(p){ return p.period<maxPeriod || p.period===0; });
  if(filtered.length<2 && chartData.length>=2) filtered = chartData;
  var chartEl=$('cwcr-detail-chart');
  var _prevIsUsd=chartSym==='$';
  cwcrRenderChart(filtered,chartEl,chartSym);
  if(_prevIsUsd && chartEl){ chartEl.insertAdjacentHTML('afterbegin','<div class="cwcr-price-hero-usd" style="margin-bottom:8px">'+esc(I18N.usdNoChart)+'</div>'); }
  detailOverlay.querySelectorAll('.cwcr-chart-period-btn').forEach(function(b){ b.classList.remove('is-active'); });
  if(btn) btn.classList.add('is-active');
}
function cwcrTogglePtSection(hdr){
  var body=hdr.nextElementSibling;
  if(!body) return;
  var isOpen=hdr.classList.toggle('cwcr-pt-open');
  body.classList.toggle('cwcr-pt-collapsed',!isOpen);
  var svg=hdr.querySelector('svg');
  if(svg) svg.style.transform=isOpen ? 'rotate(180deg)' : '';
}
function cwcrTogglePriceTable(toggle){
  var inner=toggle.nextElementSibling;
  if(!inner) return;
  var nowCollapsed=inner.classList.toggle('cwcr-pt-inner-collapsed');
  var svg=toggle.querySelector('svg');
  if(svg) svg.style.transform=nowCollapsed ? '' : 'rotate(180deg)';
  var span=toggle.querySelector('span');
  var T=I18N;
  if(span) span.textContent=nowCollapsed ? (T.showFullTable||'Toon volledige prijstabel') : (T.hideTable||'Verberg prijstabel');
}

/* ---------- Tab Signalen ---------- */
function cwcrFillSignalen(d){
  var T=I18N;
  var el=$('cwcr-detail-signalen');
  if(!el) return;
  var sym=d.sym||'€';
  var prices=[d.nmPrice,d.avg1,d.avg7,d.avg30,d.trend].filter(function(v){ return v>0; });
  if(prices.length<2){
    el.innerHTML='<div class="cwcr-signal-empty">'+(T.notEnoughData||'Niet genoeg data voor prijssignalen.')+'</div>';
    return;
  }
  var trendDir='stable';
  if(d.avg1>0 && d.avg7>0 && d.avg30>0){
    if(d.avg1>d.avg7 && d.avg7>d.avg30) trendDir='rising';
    else if(d.avg1<d.avg7 && d.avg7<d.avg30) trendDir='falling';
  }
  var pMin=Math.min.apply(null,prices);
  var pMax=Math.max.apply(null,prices);
  var volPct=pMin>0 ? ((pMax-pMin)/pMin*100) : 0;
  var volLabel=volPct<5?(T.low||'Laag'):volPct<15?(T.medium||'Medium'):(T.high||'Hoog');
  /* Koopsignaal: NM 10%+ onder trend */
  var buySignal=d.nmPrice>0 && d.trend>0 && d.nmPrice<d.trend*0.9;
  var nmVsTrend=null;
  if(d.nmPrice>0 && d.trend>0) nmVsTrend=(d.nmPrice-d.trend)/d.trend*100;
  var spanning=null;
  var spanningRef=d.avgSell>0?d.avgSell:(d.trend>0?d.trend:0);
  if(d.low>0 && spanningRef>0) spanning=spanningRef-d.low;
  var d1vs7=null;
  if(d.avg1>0 && d.avg7>0) d1vs7=(d.avg1-d.avg7)/d.avg7*100;
  var d7vs30=null;
  if(d.avg7>0 && d.avg30>0) d7vs30=(d.avg7-d.avg30)/d.avg30*100;
  var badges='';
  if(buySignal) badges+='<div class="cwcr-signal-badge cwcr-signal-buy">'+(T.buyOpportunity||'Onder de trendprijs')+'</div>';
  if(trendDir==='rising') badges+='<div class="cwcr-signal-badge cwcr-signal-rising">'+(T.risingTrend||'Stijgende trend')+'</div>';
  else if(trendDir==='falling') badges+='<div class="cwcr-signal-badge cwcr-signal-falling">'+(T.fallingTrend||'Dalende trend')+'</div>';
  else badges+='<div class="cwcr-signal-badge cwcr-signal-stable">'+(T.stableTrend||'Stabiele trend')+'</div>';
  if(volPct>=15) badges+='<div class="cwcr-signal-badge cwcr-signal-volatile">'+(T.highVolatility||'Hoge volatiliteit')+'</div>';
  var rows='';
  var trendTxt=trendDir==='rising'?(T.rising||'Stijgend'):trendDir==='falling'?(T.falling||'Dalend'):(T.stable||'Stabiel');
  var trendCls=trendDir==='rising'?'cwcr-val-green':trendDir==='falling'?'cwcr-val-red':'cwcr-val-muted';
  rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">'+(T.priceTrend||'Prijstrend')+'</span><span class="cwcr-signal-val '+trendCls+'">'+trendTxt+'</span></div>';
  rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">'+(T.volatility||'Volatiliteit')+'</span><span class="cwcr-signal-val">'+esc(volLabel)+' ('+pct(volPct,false)+')</span></div>';
  if(nmVsTrend!==null){
    var nvtStr=pct(nmVsTrend,true)+' '+(nmVsTrend<0?(T.belowTrend||'onder trend'):(T.aboveTrend||'boven trend'));
    var nvtCls=nmVsTrend>0?'cwcr-val-green':nmVsTrend<0?'cwcr-val-red':'';
    rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">'+(T.nmVsTrend||'NM vs Trend')+'</span><span class="cwcr-signal-val '+nvtCls+'">'+esc(nvtStr)+'</span></div>';
  }
  if(spanning!==null){
    rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">'+(T.priceSpan||'Prijsspanning')+'</span><span class="cwcr-signal-val">'+money(spanning,sym)+' ('+(T.lowToAvg||'laag - gem.')+')</span></div>';
  }
  if(d1vs7!==null){
    var d1Str=pct(d1vs7,true);
    var d1Cls=d1vs7>0?'cwcr-val-green':d1vs7<0?'cwcr-val-red':'';
    rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">'+T.d1+' vs '+T.d7+'</span><span class="cwcr-signal-val '+d1Cls+'">'+esc(d1Str)+'</span></div>';
  }
  if(d7vs30!==null){
    var d7Str=pct(d7vs30,true);
    var d7Cls=d7vs30>0?'cwcr-val-green':d7vs30<0?'cwcr-val-red':'';
    rows+='<div class="cwcr-signal-row"><span class="cwcr-signal-label">'+T.d7+' vs '+T.d30+'</span><span class="cwcr-signal-val '+d7Cls+'">'+esc(d7Str)+'</span></div>';
  }
  el.innerHTML=(d.currency==='USD'?'<div class="cwcr-price-hero-usd" style="margin-bottom:8px" title="'+(T.historicalNotAvailable||'USD via TCGplayer - historische data niet beschikbaar')+'">'+(T.historicalNotAvailable||'USD via TCGplayer - historische data niet beschikbaar')+'</div>':'')+' <div class="cwcr-signals-wrap"><div class="cwcr-signal-badges">'+badges+'</div><div class="cwcr-signal-title">'+(T.priceAnalysisTitle||'Prijsanalyse')+'</div><div class="cwcr-signal-grid">'+rows+'</div></div>';
}

/* ---------- Tab Markt ---------- */
function cwcrFillMarkt(d){
  var T=I18N;
  var el=$('cwcr-detail-market');
  if(!el) return;
  var sym=d.sym||'€';
  var isUsd=d.currency==='USD';
  var html='';
  if(isUsd) html+='<div class="cwcr-price-hero-usd" style="margin-bottom:12px" title="'+(T.usdMarketNotAvailable||'USD via TCGplayer - EU marktdata niet beschikbaar')+'">'+(T.usdMarketNotAvailable||'USD via TCGplayer - EU marktdata niet beschikbaar')+'</div>';
  html += '<div class="cwcr-market-section"><div class="cwcr-market-section-title">'+(T.priceOverview||'Prijsoverzicht')+'</div>';
  var infoRows=[];
  if(d.nmPrice>0)  infoRows.push([isUsd?(T.tcgPrice||'TCGplayer Prijs'):(T.nmWorldwide||'Near Mint (Wereldwijd)'),money(d.nmPrice,sym)]);
  if(!isUsd && d.nmEU>0) infoRows.push([(T.nmEuOnly||'Near Mint (EU)'),money(d.nmEU,sym)]);
  if(d.avgSell>0)  infoRows.push([(T.avgSalePrice||'Gem. Verkoopprijs'),money(d.avgSell,sym)]);
  if(d.trend>0)    infoRows.push([(T.trendPrice||'Trendprijs'),money(d.trend,sym)]);
  if(d.low>0)      infoRows.push([(T.lowest||'Laagste'),money(d.low,sym)]);
  if(isUsd)        infoRows.push([(T.source||'Bron'),'TCGplayer (USD)']);
  infoRows.forEach(function(r){
    html += '<div class="cwcr-market-row"><span class="cwcr-market-label">' + r[0] + '</span><span class="cwcr-market-val">' + r[1] + '</span></div>';
  });
  html += '</div>';
  html += '<div class="cwcr-market-section"><div class="cwcr-market-section-title">'+(T.cardDetails||'Kaartgegevens')+'</div>';
  if(d.cardmarketId) html += '<div class="cwcr-market-row"><span class="cwcr-market-label">'+(T.cardmarketId||'Cardmarket ID')+'</span><span class="cwcr-market-val">' + d.cardmarketId + '</span></div>';
  if(d.setName)      html += '<div class="cwcr-market-row"><span class="cwcr-market-label">'+(T.setLabel||'Set')+'</span><span class="cwcr-market-val">' + esc(d.setName) + '</span></div>';
  if(d.rarity)       html += '<div class="cwcr-market-row"><span class="cwcr-market-label">'+(T.rarity||'Rariteit')+'</span><span class="cwcr-market-val">' + esc(d.rarityLabel) + '</span></div>';
  if(d.isOp && d.color) html += '<div class="cwcr-market-row"><span class="cwcr-market-label">'+(T.color||'Kleur')+'</span><span class="cwcr-market-val">' + esc(colorName(d.color)) + '</span></div>';
  html += '</div>';
  el.innerHTML = html;
}

/* ---------- Openen: openCardDetail uit cw-pricedex.js, ingelogde weergave ---------- */
function openCardDetail(card,franchise){
  if(!detailOverlay) return;
  cwcrCancelAllCountUps();
  nmScope='world';
  curCard = card;
  curFranchise = franchise;
  var modal=$('cwcr-detail-modal');
  if(modal) modal.classList.remove('cwcr-paywall-mode');
  var isOp=franchise==='onepiece';
  var name=isOp ? (card.name || card.card_name || '') : (card.name || '');
  var number=isOp ? (card.card_id || card.id || '') : (card.number || '');
  var rarity=card.rarity || '';
  var price=card._price || 0;
  var cardCur2=card._currency||'EUR';
  var cardSym2=cardCur2==='USD'?'$':'€';
  var cm=(card.cardmarket && card.cardmarket.prices) ? card.cardmarket.prices : null;
  var evo=(card.cardmarket && card.cardmarket.evolution) ? card.cardmarket.evolution : null;
  var avg1=cm ? (cm.avg1 || 0) : 0;
  var avg7=cm ? (cm.avg7 || 0) : (isOp ? (parseFloat(card.inventory_price) || 0) : 0);
  var avg30=cm ? (cm.avg30 || 0) : (isOp ? (parseFloat(card.market_price) || 0) : 0);
  var trend=cm ? (cm.trendPrice || 0) : 0;
  var low=cm ? (cm.lowPrice || 0) : 0;
  var nmPrice=cm ? (cm.lowestNearMint || 0) : 0;
  var nmEU=cm ? (cm.lowestNearMintEU || 0) : 0;
  var nmByCountry=(cm && cm.nmByCountry && typeof cm.nmByCountry==='object') ? cm.nmByCountry : {};
  var avgSell=cm ? (cm.averageSellPrice || 0) : 0;
  var cmLink=isOp ? opCardmarkUrl(card,number,name) : pkCardmarkUrl(card,name);
  var info=isOp ? (opRarity[rarity] || { label: rarity,cls: 'cwcr-badge-other' }) : (pkRarity[rarity] || { label: rarity,cls: 'cwcr-badge-other' });
  var imgEl=$('cwcr-detail-img');
  var nameEl=$('cwcr-detail-name');
  var numEl=$('cwcr-detail-number');
  var badgeEl=$('cwcr-detail-badge');
  var metaEl=$('cwcr-detail-meta');
  var actEl=$('cwcr-detail-actions');
  cwcrSetModalImg(imgEl, card, franchise, name);
  if(nameEl) nameEl.textContent = name;
  if(numEl) numEl.textContent = '';
  if(badgeEl){ badgeEl.textContent = info.label; badgeEl.className = 'cwcr-detail-rarity ' + info.cls; badgeEl.style.cssText = ''; }
  var imgColEl=$('cwcr-detail-img-col');
  var rarPri=info.pri || 99;
  var glowTier;
  if(isOp){glowTier=price>=1000?5:price>=100?4:price>=20?3:price>=4?2:price>0?1:0;}
  else{glowTier=rarPri<=1?5:rarPri<=2?4:rarPri<=3?3:rarPri<=5?2:rarPri<=6?1:0;}
  if(imgColEl){
    imgColEl.className = imgColEl.className.replace(/\bcwcr-glow-\d\b/g,'').trim();
    if(glowTier>0) imgColEl.classList.add('cwcr-glow-' + glowTier);
    imgColEl.dataset.franchise = isOp ? 'onepiece' : 'pokemon';
  }
  cwcrUpdateAura(glowTier);
  if(badgeEl){
    /* header-rarity is platte tekst (concept A), geen badge-glow tier */
    badgeEl.className = badgeEl.className.replace(/\bcwcr-badge-glow-\d\b/g,'').trim();
  }
  var backContent=$('cwcr-card-back-content');
  if(backContent){
    var Tb=I18N;
    var bh='<div class="cwcr-card-back-title">' + esc(name) + '</div>';
    if(rarity) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.rarityLabel||'Zeldzaamheid')+'</span><span class="cwcr-card-back-val">' + esc(info.label || rarity) + '</span></div>';
    if(number) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.numberLabel||'Nummer')+'</span><span class="cwcr-card-back-val">' + esc(number) + '</span></div>';
    if(!isOp && card.set && card.set.name) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.setLabelBack||'Set')+'</span><span class="cwcr-card-back-val">' + esc(card.set.name) + '</span></div>';
    if(!isOp && card.hp) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">HP</span><span class="cwcr-card-back-val">' + esc(String(card.hp)) + '</span></div>';
    var cardTypes=(!isOp && card.types) ? (Array.isArray(card.types) ? card.types : [card.types]) : [];
    if(cardTypes.length) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.typeLabel||'Type')+'</span><span class="cwcr-card-back-val">' + cardTypes.map(esc).join(',') + '</span></div>';
    if(isOp && card.color)     bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.colorLabel||'Kleur')+'</span><span class="cwcr-card-back-val">' + esc(colorName(card.color)) + '</span></div>';
    if(isOp && card.card_type && card.card_type!=='singles') bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.typeLabel||'Type')+'</span><span class="cwcr-card-back-val">' + esc(card.card_type) + '</span></div>';
    if(isOp && card.power)     bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">Power</span><span class="cwcr-card-back-val">' + esc(card.power) + '</span></div>';
    if(isOp && card.life)      bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">Life</span><span class="cwcr-card-back-val">' + esc(card.life) + '</span></div>';
    if(isOp && card.counter)   bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">Counter</span><span class="cwcr-card-back-val">' + esc(card.counter) + '</span></div>';
    if(price>0) bh += '<div class="cwcr-card-back-row"><span class="cwcr-card-back-label">'+(Tb.priceLabel||'Prijs')+'</span><span class="cwcr-card-back-val" style="color:var(--cwcr-gold)">'+money(price,cardSym2) + '</span></div>';
    backContent.innerHTML = bh;
  }
  if(resetFlip) resetFlip();
  if(resetZoom) resetZoom();
  /* Meta als een rustige tekstregel (concept A): nummer, kleur, set met middot-scheiding */
  var metaParts=[];
  var _setNameForTag = isOp ? (card.set_name || '') : ((card.set && card.set.name) || '');
  var _opColorMap={'Red':'#ff5555','Green':'#22c55e','Blue':'#60a5fa','Purple':'#a855f7','Black':'#2b2535','Yellow':'#eab308','Multi':'#e879f9'};
  if(number) metaParts.push('<span class="cwcr-meta-num">' + esc('#' + number) + '</span>');
  if(isOp && card.color){var _col=_opColorMap[card.color]||'#a78bfa';metaParts.push('<span class="cwcr-meta-color"><span class="cwcr-meta-dot" style="background:'+_col+'"></span>' + esc(colorName(card.color)) + '</span>');}
  if(isOp && card.card_type && card.card_type!=='singles') metaParts.push('<span>' + esc(card.card_type) + '</span>');
  if(_setNameForTag) metaParts.push('<span>' + esc(_setNameForTag) + '</span>');
  if(metaEl) metaEl.innerHTML = metaParts.join('<span class="cwcr-meta-sep">&middot;</span>');
  var d={
    isOp: isOp,name: name,number: number,rarity: rarity,rarityLabel: info.label || rarity,price: price,nmPrice: nmPrice,nmEU: nmEU,nmByCountry: nmByCountry,avgSell: avgSell,avg1: avg1,avg7: avg7,avg30: avg30,trend: trend,low: low,evo: evo,cmLink: cmLink,tcggoUrl: card.tcggo_url || '',cardmarketId: card.cardmarket_id || null,setName: isOp ? (card.set_name || '') : ((card.set && card.set.name) || ''),color: card.color || '',currency: cardCur2,sym: cardSym2
  };
  cwcrFillOverzicht(d);
  cwcrFillAnalyse(d);
  cwcrFillSignalen(d);
  cwcrFillMarkt(d);
  cwcrInitTabs();
  cwcrSwitchTab('overzicht');
  var Ta=I18N;
  var ah='';
  ah += '<div class="cwcr-detail-btn-row">';
  /* hideShop (Rip Lab, 10 okt): geen "Shop bij Cardworld"; de knopenrij houdt dan enkel Kopieer kaartlink */
  if(!hideShop) ah += '<button type="button" class="cwcr-detail-btn cwcr-detail-btn-cw" data-pdxm-act="shop">' +
    '<img src="'+CWCR_LOGO_URL+'" alt="" width="22" height="22" style="flex-shrink:0;filter:drop-shadow(0 0 5px rgba(123,94,167,0.7));" onerror="this.style.display=\'none\'">' +
    (Ta.shopAtCw||'Shop bij Cardworld')+'</button>';
  /* "Kopieer kaartlink": kopieert direct naar het klembord (geen OS share-sheet) */
  ah += '<button type="button" class="cwcr-detail-btn cwcr-detail-btn-share" id="cwcr-modal-share-btn" data-pdxm-act="copy">' +
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>' +
    (Ta.copyCardLink||'Kopieer kaartlink')+'</button>';
  ah += '</div>';
  /* Cardmarket bronlink onder de knoppen, opent in een nieuw tabblad zoals het origineel */
  ah += '<a href="' + esc(cmLink) + '" target="_blank" rel="noopener" class="cwcr-detail-source-link" id="cwcr-source-link-btn">' + (cardCur2==='USD' ? (Ta.viewOnTcg||'Bekijk op TCGplayer') : (Ta.viewCmSource||'Bekijk bronprijs op Cardmarket')) + ' <svg class="cwcr-ext-arrow" viewBox="0 0 12 12" width="10" height="10" aria-hidden="true"><path d="M4 2h6v6M10 2 3 9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
  if(actEl) actEl.innerHTML = ah;
  /* Elke opening start bovenaan, ook als de vorige kaart naar onder gescrold was */
  var infoCol=$('cwcr-detail-info-col');
  if(infoCol) infoCol.scrollTop=0;
  detailOverlay.scrollTop=0;
  detailOverlay.style.display='flex';
  if(!openState){
    openedAt=Date.now();
    prevBodyOverflow=document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    histPush();
  }
  openState=true;
}
/* een entry bovenop de huidige, zelfde URL, de bestaande state behouden (Chase op gsm leest er zijn stapnummer uit) */
function histPush(){
  if(histTok) return;
  var tok='p'+Date.now().toString(36)+Math.random().toString(36).slice(2,6);
  try{ history.pushState(Object.assign({}, history.state, { cwPdxm:tok }), '', location.href); histTok=tok; }catch(e){ histTok=null; }
}
function histMine(){ var st=history.state; return !!(histTok && st && typeof st==='object' && st.cwPdxm===histTok); }
/* sluiten door de bezoeker (X, Escape, klik ernaast): staat onze entry nog bovenaan, dan een stap terug, zodat Terug daarna
   niet eerst op een lege stap valt. De pop-up gaat meteen dicht, de popstate die volgt vangt closeOnNav op. */
function closeByUser(){
  if(!openState) return;
  var mine=histMine(); histTok=null;
  closeCardDetail();
  if(!mine) return;
  histBack=true; clearTimeout(histBackT); histBackT=setTimeout(function(){ histBack=false; },1500);
  try{ history.back(); }catch(e){ histBack=false; }
}
/* naar de vorige of volgende kaart (pijltjestoets of veeg): zelfde pop-up, nieuwe inhoud, kort glijden (enkel transform en opacity) */
function navGo(dir){
  if(!navFn || !openState) return;
  var r=navFn(dir); if(!r || !r.k) return;
  if(resetFlip) resetFlip(); if(resetZoom) resetZoom();
  var nav=navFn;
  if(!window.PDXModal.open(r.k, r.live, { hideShop: hideShop ? undefined : false, nav: nav })) { navFn=nav; nav(-dir); return; } /* mislukt: de teller terugzetten */
  var rm=window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(rm) return;
  ['cwcr-detail-img-col','cwcr-detail-info-col'].forEach(function(id){
    var el=$(id); if(el && el.animate) el.animate([{ opacity:0, transform:'translateX('+(dir*28)+'px)' },{ opacity:1, transform:'none' }],{ duration:280, easing:'cubic-bezier(.22,1,.36,1)' });
  });
}
/* teller en pijlen boven de kaart ("3 / 12"), enkel als er een lijst is om door te bladeren */
function navUi(){
  var col=$('cwcr-detail-modal'); if(!col) return; /* in het paneel (relatief), boven het midden van de kaartkolom */
  var bar=$('cwcr-nav');
  if(!bar){
    bar=document.createElement('div'); bar.id='cwcr-nav'; bar.className='cwcr-nav';
    var chev=function(d){ return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+(d<0?'M15 6l-6 6 6 6':'M9 6l6 6-6 6')+'" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
    bar.innerHTML='<button type="button" class="cwcr-nav-b" data-nav="-1" aria-label="'+esc(I18N.prevCard)+'">'+chev(-1)+'</button><span class="cwcr-nav-n" aria-live="polite"></span><button type="button" class="cwcr-nav-b" data-nav="1" aria-label="'+esc(I18N.nextCard)+'">'+chev(1)+'</button>';
    bar.addEventListener('click',function(e){ var b=e.target.closest && e.target.closest('[data-nav]'); if(b){ e.stopPropagation(); navGo(+b.getAttribute('data-nav')); } });
    col.insertBefore(bar,col.firstChild);
  }
  var r=navFn ? navFn(0) : null;
  if(!r || !(r.n>1)){ bar.hidden=true; return; }
  bar.hidden=false; bar.querySelector('.cwcr-nav-n').textContent=(r.i+1)+' / '+r.n;
}
function closeCardDetail(){
  navFn=null;
  var nb=$('cwcr-nav'); if(nb) nb.hidden=true;
  cwcrCancelAllCountUps();
  if(detailOverlay) detailOverlay.style.display='none';
  if(openState){
    document.body.style.overflow = prevBodyOverflow || '';
    prevBodyOverflow=null;
  }
  openState=false;
  if(resetFlip)  resetFlip();
  if(resetZoom)  resetZoom();
  var modalEl2=$('cwcr-detail-modal');
  if(modalEl2) modalEl2.classList.remove('cwcr-paywall-mode');
}

/* ---------- Delen en kopieren: zelfde gedrag, maar altijd de publieke cardworld.be-link ---------- */
function buildShareData(){
  var T=I18N;
  var url=PD_ORIGIN+'/pages/pricedex';
  var cardName='';
  try{
    var card=curCard, fr=curFranchise;
    if(card){
      var isOp=(fr==='onepiece');
      cardName = isOp?(card.name||card.card_name||''):(card.name||'');
      var setId=(card._setId || card.set_id) || (card.set && card.set.id) || curSetId || '';
      if(fr && setId){
        url=PD_ORIGIN+CWCR_PD_BASE+'/'+(isOp?'one-piece':'pokemon')+'/'+encodeURIComponent(setId)+'/'+cardSlug(card,isOp);
      }
    }
  }catch(_){}
  var title = cardName ? (cardName + ' | CARDWORLD PriceDex') : 'CARDWORLD PriceDex';
  var text = (T.shareText || 'Bekijk {name} op CARDWORLD PriceDex.').replace('{name}', cardName || T.thisCard || 'deze kaart');
  return { url: url, title: title, text: text };
}
function copyToClipboard(url){
  function legacy(){
    return new Promise(function(resolve, reject){
      try {
        var ta=document.createElement('textarea');ta.value=url;ta.style.cssText='position:fixed;opacity:0';
        document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);
        resolve();
      } catch(err){ reject(err); }
    });
  }
  if(navigator.clipboard && navigator.clipboard.writeText){
    return navigator.clipboard.writeText(url).catch(legacy);
  }
  return legacy();
}
/* Kaartafbeelding + caption in een strook eronder, voor Web Share met bestand (iOS) */
function buildShareFile(captionText, shareUrl){
  return new Promise(function(resolve){
    try {
      var card=curCard, fr=curFranchise;
      if(!card){ resolve(null); return; }
      var isOp = (fr === 'onepiece');
      var imgUrl = isOp
        ? (card.image_url || card.image || card.card_image || card.img || '')
        : (card.images ? (card.images.large || card.images.small || '') : '');
      if(!imgUrl){ resolve(null); return; }
      var nameEl = $('cwcr-detail-name');
      var nmRaw  = nameEl ? (nameEl.textContent||'').trim() : '';
      var nm = nmRaw.replace(/[^a-z0-9-]/gi,'-').replace(/-+/g,'-').replace(/^-|-$/g,'').slice(0,40) || 'card';
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function(){
        try {
          var w  = img.naturalWidth  || 600;
          var h  = img.naturalHeight || 840;
          var pad   = Math.round(w * 0.035);
          var capFS = Math.max(18, Math.round(w * 0.034));
          var urlFS = Math.max(14, Math.round(w * 0.026));
          var gap   = Math.round(capFS * 0.25);
          var footH = pad + capFS + gap + urlFS + pad;
          var c     = document.createElement('canvas');
          c.width = w; c.height = h + footH;
          var ctx = c.getContext('2d');
          ctx.fillStyle = '#0d0716'; ctx.fillRect(0, 0, w, h + footH);
          ctx.drawImage(img, 0, 0, w, h);
          ctx.fillStyle = '#15092a'; ctx.fillRect(0, h, w, footH);
          ctx.fillStyle = '#ffffff';
          ctx.font = '500 ' + capFS + 'px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
          ctx.textBaseline = 'top'; ctx.textAlign = 'left';
          var cap = captionText || '';
          var maxW = w - pad*2;
          while(ctx.measureText(cap).width > maxW && cap.length > 10){ cap = cap.slice(0, -2); }
          if(cap !== (captionText||'')) cap += '…';
          ctx.fillText(cap, pad, h + pad);
          ctx.fillStyle = '#9d7fd9';
          ctx.font = '400 ' + urlFS + 'px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
          var urlText = (shareUrl || '').replace(/^https?:\/\//, '');
          while(ctx.measureText(urlText).width > maxW && urlText.length > 10){ urlText = urlText.slice(0, -2); }
          ctx.fillText(urlText, pad, h + pad + capFS + gap);
          c.toBlob(function(blob){
            if(!blob){ resolve(null); return; }
            var file = new File([blob], nm + '.jpg', { type: 'image/jpeg' });
            if(navigator.canShare && navigator.canShare({ files:[file] })) resolve(file);
            else resolve(null);
          }, 'image/jpeg', 0.92);
        } catch(_){ resolve(null); }
      };
      /* Geen CORS-afbeelding: deel dan gewoon de link */
      img.onerror = function(){ resolve(null); };
      img.src = imgUrl;
    } catch(_){ resolve(null); }
  });
}
function flashBtn(btn,msg){
  if(!btn) return;
  var o=btn.innerHTML; btn.textContent=msg;
  setTimeout(function(){ btn.innerHTML=o; },2000);
}
/* Native share (Web Share API) met terugval op kopieren, zoals cwcrNativeShareCard */
function nativeShareCard(e){
  if(e) e.stopPropagation();
  var btn=$('cwcr-share-btn');
  var T=I18N;
  var sd=buildShareData();
  var copyFb=function(){ copyToClipboard(sd.url).then(function(){flashBtn(btn,T.copied||'Gekopieerd!');}).catch(function(){flashBtn(btn,T.copyFailed||'Mislukt');}); };
  if(!navigator.share){ copyFb(); return; }
  buildShareFile(sd.text, sd.url).then(function(file){
    var payload = file ? { text: sd.text + '\n\n' + sd.url, files: [file] } : { text: sd.text + '\n', url: sd.url };
    navigator.share(payload).catch(function(err){
      if(err && (err.name==='AbortError' || err.message==='AbortError')) return;
      if(file){
        navigator.share({ text: sd.text, url: sd.url }).catch(function(err2){
          if(err2 && (err2.name==='AbortError' || err2.message==='AbortError')) return;
          copyFb();
        });
      } else copyFb();
    });
  });
}
function copyCardLink(btn){
  var T=I18N;
  var sd=buildShareData();
  copyToClipboard(sd.url).then(function(){flashBtn(btn,T.copied||'Gekopieerd!');}).catch(function(){flashBtn(btn,T.copyFailed||'Mislukt');});
}
/* "Shop bij Cardworld": de mockup kan dit opvangen via het event pdxmodal:shop
   (preventDefault = zelf afhandelen); anders opent de shop in een nieuw tabblad. */
function openShop(){
  var ev;
  try{ ev=new CustomEvent('pdxmodal:shop',{ cancelable:true, detail:{ card: curCard, franchise: curFranchise } }); }catch(_){ ev=null; }
  if(ev && !document.dispatchEvent(ev)) return;
  window.open(SHOP_URL,'_blank','noopener');
}

/* ---------- Initialisatie: handlers een keer binden ---------- */
function init(){
  if(inited) return true;
  detailOverlay=$('cwcr-detail-overlay');
  if(!detailOverlay) return false;
  detailClose=$('cwcr-detail-close');
  bindTilt();
  bindHolo();
  bindZoom();
  bindFlip();
  var shareBtn=$('cwcr-share-btn');
  if(shareBtn) shareBtn.addEventListener('click',nativeShareCard);
  if(detailClose) detailClose.addEventListener('click',closeByUser);
  /* Klik buiten de inhoud (op de overlay zelf) sluit, zoals het origineel */
  /* veeg links of rechts (gsm): vorige of volgende kaart; niet tijdens zoom en niet op de grafiek of de tabrij */
  var sw=null;
  detailOverlay.addEventListener('touchstart',function(e){
    if(!navFn || e.touches.length!==1) { sw=null; return; }
    var t=e.target; if(t && t.closest && t.closest('canvas,.cwcr-detail-chart,.cwcr-chart-container,.cwcr-tab-nav,.cwcr-img-zoomed,input,textarea')) { sw=null; return; }
    sw={ x:e.touches[0].clientX, y:e.touches[0].clientY, t:Date.now() };
  },{ passive:true });
  detailOverlay.addEventListener('touchend',function(e){
    if(!sw || !e.changedTouches.length) return;
    var dx=e.changedTouches[0].clientX-sw.x, dy=e.changedTouches[0].clientY-sw.y, dt=Date.now()-sw.t; sw=null;
    if(Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)*1.5 && dt<700) navGo(dx<0 ? 1 : -1);
  },{ passive:true });
  detailOverlay.addEventListener('click',function(e){
    if(e.target===detailOverlay){ closeByUser(); return; }
    var t=e.target.closest ? e.target.closest('[data-pdxm-scope],[data-pdxm-period],[data-pdxm-act]') : null;
    if(!t || !detailOverlay.contains(t)) return;
    if(t.hasAttribute('data-pdxm-scope')){ cwcrSetNmScope(t.getAttribute('data-pdxm-scope')); return; }
    if(t.hasAttribute('data-pdxm-period')){ cwcrFilterChart(parseInt(t.getAttribute('data-pdxm-period'),10),t); return; }
    var act=t.getAttribute('data-pdxm-act');
    if(act==='pt-section') cwcrTogglePtSection(t);
    else if(act==='pt-table') cwcrTogglePriceTable(t);
    else if(act==='shop'){ e.stopPropagation(); if(!hideShop) openShop(); }
    else if(act==='copy'){ e.stopPropagation(); copyCardLink(t); }
  });
  inited=true;
  return true;
}

/* Escape sluit de pop-up en gaat NIET door naar andere Escape-luisteraars van de pagina.
   Zolang de pop-up open is, bereikt geen enkele toets de sneltoetsen van de pagina eronder
   (pijltjes, j/k, /, Tab-val van een sheet). Het standaardgedrag (scrollen, focus, Enter op een
   knop) blijft werken, want we roepen enkel bij Escape preventDefault op. */
window.addEventListener('keydown',function(e){
  if(!openState) return;
  e.stopImmediatePropagation();
  if(navFn && (e.key==='ArrowLeft' || e.key==='ArrowRight')){
    var tg=e.target; if(tg && /^(INPUT|TEXTAREA|SELECT)$/.test(tg.tagName)) return;
    e.preventDefault(); navGo(e.key==='ArrowRight' ? 1 : -1); return;
  }
  if(e.key==='Escape' || e.key==='Esc'){
    e.preventDefault();
    closeByUser();
  }
}, true);

/* 16 okt (audit): browser-Terug of een andere hash met de pop-up open sluit de pop-up, anders bleef ze over de Shop hangen.
   Terug gaat van onze eigen entry (histPush) naar de entry eronder, met dezelfde URL: die popstate is van ons. We sluiten en houden
   hem weg van de luisteraars die na de onze komen (stopImmediatePropagation); wie eerder loopt, vraagt het via PDXModal.ownsPop(),
   zodat de productpagina, het streamscherm en Chase op hun stap blijven. Zo sluit Terug enkel de bovenste laag.
   Een popstate binnen 500 ms na openen komt van een history.back() die al liep (bv. een sheet die sloot): die is niet van ons en gaat
   gewoon door naar de pagina; nam hij onze entry mee, dan zetten we een nieuwe, zodat de volgende Terug nog altijd enkel de pop-up sluit. */
function closeOnPop(e){
  if(histBack){ histBack=false; clearTimeout(histBackT); e.stopImmediatePropagation(); return; } /* onze eigen stap terug na X of Escape */
  if(!openState) return;
  if(histMine()) return; /* (Vooruit) weer op onze entry: niets te doen */
  if(Date.now()-openedAt<500){ if(histTok){ histTok=null; histPush(); } return; }
  var mine=!!histTok; histTok=null;
  closeCardDetail();
  if(mine) e.stopImmediatePropagation();
}
/* een andere hash (link, adresbalk): sluiten; die navigatie hoort bij de pagina */
function closeOnHash(){
  if(!openState) return;
  if(Date.now()-openedAt<500) return;
  histTok=null;
  closeCardDetail();
}
window.addEventListener('popstate',closeOnPop,true);
window.addEventListener('hashchange',closeOnHash);

if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ init(); });
else init();

window.PDXModal = {
  /* k = sleutel uit topcards.json, bv. "pokemon|151|199" of "one-piece|OP12|OP09-093|843037".
     live (optioneel, 10 okt) = { franchise, card }: een live kaartobject van de PriceDex-bron (Rip Lab-wizard), dat dan
     voorgaat op de ingebakken momentopname zodat de weergave dezelfde prijs toont als waar de klant op klikte */
  open: function(k, live, opts){
    if(!init()) return false;
    applyLang();
    /* Rip Studio (eigenaar 10 okt): wie hier binnenkomt zit al in de winkel, dus standaard geen "Shop bij Cardworld";
       enkel tonen als een aanroeper uitdrukkelijk { hideShop:false } meegeeft */
    hideShop=!(opts && opts.hideShop===false);
    navFn=(opts && typeof opts.nav==='function') ? opts.nav : null;
    var entry=(live && live.card) ? live : data()[k];
    if(!entry || !entry.card){
      /* kaartzoeker in de chat (6 okt): niet ingebakken kaarten komen van de CARDIX-server (/cardix/card?k=) */
      var base=null; try{ base=window.CDX && window.CDX.base; }catch(e){ base=null; }
      if(!base || window.CW_CARDIX===false) return false; /* CARDIX uit (pack.js CARDIX_AAN): geen verzoek naar de CARDIX-server */
      var hdr={}; try{ if(window.CW_RS_CARDIX && window.CW_RS_CARDIX.token) hdr['X-Cardix-Token']=window.CW_RS_CARDIX.token; }catch(e){}
      fetch(base+'/cardix/card?k='+encodeURIComponent(k),{cache:'no-store',headers:hdr}).then(function(r){ return r.ok?r.json():null; }).then(function(e){
        if(!e || !e.card) return; data()[k]=e; var p=prepareCard(e,k); curSetId=p.setId; openCardDetail(p.card,p.franchise); navUi();
      }).catch(function(){});
      return true;
    }
    var p=prepareCard(entry,k);
    curSetId=p.setId;
    openCardDetail(p.card,p.franchise);
    navUi();
    return true;
  },
  /* sluiten door de pagina zelf (bv. "Shop bij Cardworld"): geen stap terug, want de pagina schrijft meteen daarna zelf haar adres;
     onze entry wordt dan de hare */
  close: function(){ histTok=null; if(openState) closeCardDetail(); },
  isOpen: function(){ return openState; },
  /* hoort de lopende popstate bij de pop-up (Terug sluit enkel haar, of onze eigen stap terug na X/Escape)? Voor luisteraars van de
     pagina die voor de onze lopen (in Chromium volgen luisteraars op window de volgorde van registratie, ook in de capture-fase) */
  ownsPop: function(){ return histBack || (openState && !!histTok && !histMine() && Date.now()-openedAt>=500); }
};
})();

